import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import moment from 'moment';
import adwords from '../../../../../assets/images/adwords.png';
import meta from '../../../../../assets/images/meta.png';
import dv360 from '../../../../../assets/images/dv360.png';
import tiktok from '../../../../../assets/images/tiktok.png';
import ion from '../../../../../assets/images/ion.png';
import ViLogo from '../../../../../assets/images/ViLogo.png'; 
import { Modal } from 'semantic-ui-react';
import {
  adwordsFormFields, adwordsDisplayFormFields, adwordsFormFieldsCampaignName,
  facebookFormFieldsCampaignName, facebookDisplayFormFields, facebookVideoFormFields,
  dv360VideoFormFields, dv360DisplayFormFields, dv360FormFieldsCampaignName,
  tiktokVideoFormFields, tiktokFormFieldsCampaignName,
  ionDisplayFormFields, ionVideoFormFields,viAdsDisplayFormFields,viAdsVideoFormFields
} from './constant';
import Input from '../../../../../components/FormElements/Input'
import SelectNew from '../../../../../components/FormElements/SelectNew'
import Datepicker from '../../../../../components/FormElements/Datepicker';
import { handleFieldError, handleError } from '../../../../../utils/form-validation';
import './customPlans.scss';
import ToastModal from "../../../../../components/ToastModal";
import RecommendedPlans from '../RecommendedPlans';
import { useFetchPlatformData } from "../../../../../hooks/useFetchPlatformData";
import { isApiCallSuccess } from "../../../../../selectors";

import {
  getCampaignListAction,
  getDataConfigAction
} from '../../../../../actions';
import { withRouter } from 'react-router-dom';
import { customPlanReduxAction } from '../../../../../actions/customPlanDetails';
import { CSSTransition } from "react-transition-group";
import { message } from 'antd';



const ionViFrequencyOption = [
  { id: 4, name: 'LifeTime' }
]

const enumdataModal = {
  google: {
    campaign: {
      campaignName: 'googleCampaignName'
    },
    key: 'google',
    selectAdType: {
      search: 'googleSearch',
      display: 'googleDisplay'
    },
    formType: {
      search: 'searchForm',
      display: 'displayForm'
    }
  },
  facebook: {
    campaign: {
      campaignName: 'facebookCampaignName'
    },
    key: 'facebook',
    selectAdType: {
      video: 'facebookVideo',
      display: 'facebookDisplay'
    },
    formType: {
      video: 'videoForm',
      display: 'displayForm'
    }
  },
  dv360: {
    campaign: {
      campaignName: 'dv360CampaignName'
    },
    key: 'dv360',
    selectAdType: {
      video: 'dv360Video',
      display: 'dv360Display'
    },
    formType: {
      video: 'videoForm',
      display: 'displayForm'
    }
  },
  tiktok: {
    campaign: {
      campaignName: 'tiktokCampaignName'
    },
    key: 'tiktok',
    selectAdType: {
      video: 'tiktokVideo',
      // display: 'facebookDisplay'
    },
    formType: {
      video: 'videoForm',
      // display: 'displayForm'
    }
  },
  ion: {
    campaign: {
      campaignName: 'ionCampaignName'
    },
    key: 'ion',
    selectAdType: {
      video: 'ionVideo',
      display: 'ionDisplay'
    },
    formType: {
      video: 'videoForm',
      display: 'displayForm'
    }
  },
  viads: {
    campaign: {
      campaignName: 'viadsCampaignName'
    },
    key: 'viads',
    selectAdType: {
      video: 'viVideo',
      display: 'viDisplay'
    },
    formType: {
      video: 'videoForm',
      display: 'displayForm'
    }
  },
}



const StepTwoContent = (props) => {
  const [showGoogleAdWordsModal, setShowGoogleAdWordsModal] = useState(false);
  const [showFacebookModal, setShowFacebookModal] = useState(false);
  const [showDV360Modal, setShowDV360Modal] = useState(false);
  const [showTikTokModal, setShowTikTokModal] = useState(false);
  const [adwordsModal, setadwordsModal] = useState(false);
  const [facebookModal, setfacebookModal] = useState(false);
  const [dv360Modal, setdv360Modal] = useState(false);
  const [tiktokModal, settiktokModal] = useState(false);
  const [ionModal, setionModal] = useState(false);
  const [viAdsModal, setViadsModal] = useState(false);
  const [showFrequencyForm, setShowFrequencyForm] = useState({
    googleDisplay: false,
    dv360Display: false,
    dv360Video: false,
    ionVideo: false,
    ionDisplay: false,
    viDisplay:false,
    viVideo:false
  })

  console.log(showFrequencyForm, "showFrequencyForm")

  const platformData = useFetchPlatformData();

  const [submited, setSubmited] = useState(false);
  const [form, setForm] = useState({
    [enumdataModal.google.key]: {
      [enumdataModal.google.formType.search]: { form: { selectedFrequencyOption: "none", }, touched: {}, errors: {} },
      [enumdataModal.google.formType.display]: { form: { selectedFrequencyOption: "none" }, touched: {}, errors: {} },
      // [enumdataModal.google.campaign.campaignName]: { form: {}, touched: {}, errors: {} }
    },
    [enumdataModal.facebook.key]: {
      [enumdataModal.facebook.formType.video]: { form: { selectedFrequencyOption: "none" }, touched: {}, errors: {} },
      [enumdataModal.facebook.formType.display]: { form: { selectedFrequencyOption: "none" }, touched: {}, errors: {} },
      [enumdataModal.facebook.campaign.campaignName]: { form: {}, touched: {}, errors: {} }
    },
    [enumdataModal.dv360.key]: {
      [enumdataModal.dv360.formType.video]: { form: { selectedFrequencyOption: "none" }, touched: {}, errors: {} },
      [enumdataModal.dv360.formType.display]: { form: { selectedFrequencyOption: "none" }, touched: {}, errors: {} },
      [enumdataModal.dv360.campaign.campaignName]: { form: {}, touched: {}, errors: {} }
    },
    [enumdataModal.tiktok.key]: {
      [enumdataModal.tiktok.formType.video]: { form: { selectedFrequencyOption: "none" }, touched: {}, errors: {} },
      [enumdataModal.tiktok.campaign.campaignName]: { form: {}, touched: {}, errors: {} }
    },
    [enumdataModal.ion.key]: {
      [enumdataModal.ion.formType.video]: { form: { selectedFrequencyOption: "none",frequencyCapPerInterval:4 }, touched: {}, errors: {} },
      [enumdataModal.ion.formType.display]: { form: { selectedFrequencyOption: "none",frequencyCapPerInterval:4 }, touched: {}, errors: {} },
    },
    [enumdataModal.viads.key]: {
      [enumdataModal.viads.formType.video]: { form: {selectedFrequencyOption: "none",frequencyCapPerInterval:4}, touched: {}, errors: {} },
      [enumdataModal.viads.formType.display]: { form: {selectedFrequencyOption: "none",frequencyCapPerInterval:4}, touched: {}, errors: {} },
    },
  });
  // const [adwordsModalData, setAdwordsModalData] = useState({}); // State to store AdWords form data
  // const [facebookModalData, setFacebookModalData] = useState({}); // State to store Facebook form data
  // const [dv360ModalData, setDV360ModalData] = useState({}); // State to store DV360 form data
  // const [tiktokModalData, setTikTokModalData] = useState({}); // State to store TikTok form data

  const [selectedModalAdType, setSelectedModalAdType] = useState({
    [enumdataModal.google.selectAdType.search]: false,
    [enumdataModal.google.selectAdType.display]: false,
    [enumdataModal.facebook.selectAdType.video]: false,
    [enumdataModal.facebook.selectAdType.display]: false,
    [enumdataModal.dv360.selectAdType.video]: false,
    [enumdataModal.dv360.selectAdType.display]: false,
    [enumdataModal.tiktok.selectAdType.video]: false,
    [enumdataModal.ion.selectAdType.video]: false,
    [enumdataModal.ion.selectAdType.display]: false,
    [enumdataModal.viads.selectAdType.video]: false,
    [enumdataModal.viads.selectAdType.display]: false,
  })

  const [pacingData, setPacingData] = useState([]);
  const [durationData, setDurationData] = useState([]);
  const [enableToast, setEnableToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastMsg, setToastMsg] = useState("");
  const [confirmationMsg, setConfirmationMsg] = useState("");
  const [totalPlatformBudget, setTotalPlatformBudget] = useState({
    google: 0,
    facebook: 0,
    dv360: 0,
    tiktok: 0,
    ion: 0,
    viads:0
  })
  const [validHighlight, setValidHighlight] = useState({
    google: false,
    facebook: false,
    dv360: false,
    tiktok: false,
    ion: false,
    viads:false
  });
  const [dataConfig, setDataConfig] = useState([]);

  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector(state => get(state, 'app.preSignInData.userId', ''));
  const authToken = useSelector(state => get(state, 'app.signInData.authToken', ''));
  const dataConfigAll = useSelector(state => get(state, 'app.dataConfigAll', ''));
  const basicDetailsForm = useSelector(state => get(state, 'app.basicDetailsForm', {}));
  const customPlanData = useSelector(state => get(state, 'app.customPlanData', {}));

  // console.log("dataConfigAll", dataConfigAll)
  const dispatch = useDispatch();

  useEffect(() => {
    // Call the dataConfigApiFunction only if dataConfigAll is empty
    // if (!dataConfigAll) {
    dataConfigApiFunction();
    // }
  }, []);

  useEffect(() => {
    const { match: { params: { id } } } = props;
    console.log("customPlanData--11", customPlanData)
    if (id) {
      getCustomPlanData(id);
    }
    else if (sessionStorage.getItem("campaignIdCreated")) {
      getCustomPlanData(id);
    }
  }, []);

  const dataConfigApiFunction = async () => {
    await dispatch(getDataConfigAction({ tenantId, authToken, userId }))
      .then((data) => {
        const {
          responseCode: { status = "" },
          response,
        } = data;

        setDataConfig(response);

        if (status === "Success") {

          console.log("data", data)

          const pacingResponse = response.filter(item =>
            item.name == "Pacing_Type" || "Pacing-Type"
          );

          if (pacingResponse) {
            setPacingData(pacingResponse[0].list);
            // setPacingData([
            //   {
            //     "id": 8,
            //     "name": "EVEN",
            //     "createdOn": "2023-11-06 12:06:25",
            //     "createdBy": 1,
            //     "modifiedBy": 0
            //   },
            //   {
            //     "id": 9,
            //     "name": "ASAP",
            //     "createdOn": "2023-11-06 12:06:25",
            //     "createdBy": 1,
            //     "modifiedBy": 0
            //   }
            // ]);
          }

          const durationTypeResponse = response.filter(item =>
            item.name == "Duration-Type" || "Duration_Type"
          );
          if (durationTypeResponse) {
            setDurationData(durationTypeResponse[0].list);
            // setDurationData([
            //   {
            //     "id": 10,
            //     "name": "Daily",
            //     "createdOn": "2023-11-06 12:06:25",
            //     "createdBy": 1,
            //     "modifiedBy": 0
            //   },
            //   {
            //     "id": 11,
            //     "name": "Lifetime",
            //     "createdOn": "2023-11-06 12:06:25",
            //     "createdBy": 1,
            //     "modifiedBy": 0
            //   }
            // ]);
          }
        } else {
          console.log("List data not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });

  }

  const getCustomPlanData = async () => {
    console.log("i am here")
    let params = { plan: 'list', mandateId: basicDetailsForm.campaignIdCreated };
    await dispatch(getCampaignListAction({ tenantId, authToken, userId, params })).then((data) => {
      // console.log("data", data)
      const {
        responseCode: { status = "" },
        responseObj,
      } = data;

      if (isApiCallSuccess(status)) {
        // Call the function with your response data
        // setFormWithResponse(responseObj);
        console.log(responseObj, 'RESPONSE OBJ');
        dispatch(
          customPlanReduxAction({
            // customDetailsForm: {},
            customPlanResponse: responseObj
          })
        );
        setFormWithResponse(responseObj);

      } else {
        console.log("Campaign List by Id Api failed!");
      }
    }).catch((error) => {
      console.error(error);
    });
  }


  const setFormWithResponse = (response) => {
    console.log("response", response)
    const newSelectedModalAdTypeState = { ...selectedModalAdType };
    let updatedForm = { ...form }
    Object.keys(response).forEach((platformKey) => {
      const platformKeyMappingTest = {
        ads: 'google',
        meta: 'facebook',
        dv360: 'dv360',
        tiktok: 'tiktok',
        ion: 'ion',
        viads:'viads'
        // Add more platforms as needed
      };

      let totalBudget = 0;
      Array.isArray(response[platformKey]) && response[platformKey].forEach((data, index) => {
        totalBudget = parseInt(data.totalBudget) + totalBudget;
      })

      setTotalPlatformBudget((prevValue) => {
        return {
          ...prevValue,
          [platformKeyMappingTest[platformKey]]: totalBudget
        }
      })
    })


    Object.keys(response).forEach((platformKey) => {
      const platformKeyMapping = {
        ads: 'google',
        meta: 'facebook',
        dv360: 'dv360',
        tiktok: 'tiktok',
        ion: 'ion',
        viads:'viads'
        // Add more platforms as needed
      };



      const mappedPlatformKey = platformKeyMapping[platformKey];

      if (!mappedPlatformKey) {
        console.error(`Invalid platform key: ${platformKey}`);
        return;
      }

      const responseObj = response[platformKey];

      if (!responseObj) {
        console.error(`Invalid response object for platform: ${platformKey}`);
        return;
      }

      responseObj.forEach((ad) => {
        const adTypeSelectKey = (() => {
          switch (ad.type) {
            case 0:
              return enumdataModal[mappedPlatformKey].selectAdType.display;
            case 1:
              return enumdataModal[mappedPlatformKey].selectAdType.video;
            case 2:
              return enumdataModal[mappedPlatformKey].selectAdType.search;
            case 3:
              return `${enumdataModal[mappedPlatformKey].selectAdType.display},${enumdataModal[mappedPlatformKey].selectAdType.video}`;
            default:
              return '';
          }
        })();

        const adTypeFormKey = (() => {
          switch (ad.type) {
            case 0:
              return enumdataModal[mappedPlatformKey].formType.display;
            case 1:
              return enumdataModal[mappedPlatformKey].formType.video;
            case 2:
              return enumdataModal[mappedPlatformKey].formType.search;
            case 3:
              return `${enumdataModal[mappedPlatformKey].formType.display},${enumdataModal[mappedPlatformKey].formType.video}`;
            default:
              return '';
          }
        })();

        Object.keys(ad).forEach((name) => {
          const adwordsFormFieldKey = (() => {
            switch (name) {
              case 'campaignName':
                return adwordsFormFields.campaignName.key
              case 'pacingType':
                return adwordsFormFields.pacing.key;
              case 'duration':
                return adwordsFormFields.duration.key;
              case 'startDate':
                return adwordsFormFields.startDate.key;
              case 'endDate':
                return adwordsFormFields.endDate.key;
              case 'totalBudget':
                return adwordsFormFields.budget.key;
              case 'frequencyCapForLevel':
                return adwordsFormFields.frequencyCapForLevel.key;
              case 'frequencyCapTo':
                return adwordsFormFields.frequencyCapTo.key;
              case 'frequencyCapPerInterval':
                return adwordsFormFields.frequencyCapPerInterval.key;
              case 'freqCap':
                return 'freqCap';
              default:
                return name;
            }
          })();

          let formattedValue = ad[name] ? ad[name] : "";
          if (adwordsFormFieldKey === 'startDate' || adwordsFormFieldKey === 'endDate') {
            formattedValue = new Date(ad[name]);
          }
          if (adwordsFormFieldKey === 'freqCap') {
            // To set Frequency Capping we are keeping this in order to set that specific form : platformFormKey

            setForm((prevForm) => {
              const platformFormKey = adwordsFormFieldKey === 'campaignName' && ['facebook', 'dv360', 'tiktok'].includes(mappedPlatformKey)
                ? (enumdataModal[mappedPlatformKey] && enumdataModal[mappedPlatformKey].campaign && enumdataModal[mappedPlatformKey].campaign.campaignName)
                : adTypeFormKey;

              updatedForm = {
                ...prevForm,
                [mappedPlatformKey]: {
                  ...(prevForm[mappedPlatformKey] || {}),
                  [platformFormKey]: {
                    ...(prevForm[mappedPlatformKey] && prevForm[mappedPlatformKey][platformFormKey] || {}),
                    form: {
                      ...(prevForm[mappedPlatformKey] && prevForm[mappedPlatformKey][platformFormKey] && prevForm[mappedPlatformKey][platformFormKey].form || {}),
                      frequencyCapForLevel: ad.freqCap.level ? ad.freqCap.level : "",
                      frequencyCapTime: ad.freqCap.time ? ad.freqCap.time : "",
                      frequencyCapTo: ad.freqCap.cap,
                      frequencyCapPerInterval: ad.freqCap.interval,
                      selectedFrequencyOption: ad.freqCap ? "limited" : "none"
                    },
                  },
                },
              };
              console.log("platformFormKey", platformFormKey)
              return updatedForm; // Return the updated form for the state update
            });

            setShowFrequencyForm((prevForm) => {
              return {
                ...prevForm,
                [adTypeSelectKey]: ad.freqCap ? true : false
              }
            })

          }
          console.log("123 ad.type", ad.type)
          console.log("123 adTypeSelectKey", adTypeSelectKey)
          console.log("123 mappedPlatformKey", mappedPlatformKey)
          console.log("123 adTypeFormKey", adTypeFormKey)
          console.log("123 adwordsFormFieldKey", adwordsFormFieldKey)
          console.log("123 formattedValue", formattedValue)

          console.log("enumdataModal[mappedPlatformKey].campaign.campaignName;", enumdataModal[mappedPlatformKey].campaign.campaignName)
          if(mappedPlatformKey == "dv360" && adwordsFormFieldKey == "freqCap" && formattedValue && formattedValue.interval)
          {
            calculateFrequencyCapTime(formattedValue.interval,adTypeFormKey)
          }

          setForm((prevForm) => {
            const platformFormKey = adwordsFormFieldKey === 'campaignName' && ['facebook', 'dv360', 'tiktok'].includes(mappedPlatformKey)
              ? (enumdataModal[mappedPlatformKey] && enumdataModal[mappedPlatformKey].campaign && enumdataModal[mappedPlatformKey].campaign.campaignName)
              : adTypeFormKey;

            updatedForm = {
              ...prevForm,
              [mappedPlatformKey]: {
                ...(prevForm[mappedPlatformKey] || {}),
                [platformFormKey]: {
                  ...(prevForm[mappedPlatformKey] && prevForm[mappedPlatformKey][platformFormKey] || {}),
                  form: {
                    ...(prevForm[mappedPlatformKey] && prevForm[mappedPlatformKey][platformFormKey] && prevForm[mappedPlatformKey][platformFormKey].form || {}),
                    [adwordsFormFieldKey]: formattedValue,
                  },
                },
              },
            };

            console.log("updatedForm", updatedForm)

            return updatedForm; // Return the updated form for the state update
          });
        });

        newSelectedModalAdTypeState[adTypeSelectKey] = ad.status;

      });

      Object.keys(newSelectedModalAdTypeState).forEach((adType) => {
        if (!newSelectedModalAdTypeState[adType]) {
          newSelectedModalAdTypeState[adType] = false;
        }
      });

      callBackParentSetResponse(updatedForm, newSelectedModalAdTypeState); // Pass the updated form to callBackParent
      setSelectedModalAdType(newSelectedModalAdTypeState);
      setHighlight(mappedPlatformKey)

    });
  };

  console.log(form, 'RRRRRRRRRRRRRRR');


  const handleTouch = (e, key1, key2, formFields = {}) => {
    const { name, value } = e.target;
    console.log(value, '####',);
    const { error } = handleFieldError(value, formFields[name]);
    console.log(error);
    setForm((prevForm) => ({
      ...prevForm,
      [key1]: {
        ...prevForm[key1],
        [key2]: {
          ...prevForm[key1][key2],
          errors: {
            ...prevForm[key1][key2].errors,
            [name]: error
          },
          touched: {
            ...prevForm[key1][key2].touched,
            [name]: true
          }
        },
      },
    }));
    // setErrors({ ...errors, [name]: error });
    // setTouched({ ...touched, [name]: true });
  };

  const calculateFrequencyCapTime = (perInterval, type) => {
    console.log("perInterval", perInterval, type);
    let value = '';
    if (perInterval == 0) {
      if (type.includes('display')) {
        console.log('hello,*****************')
        dv360DisplayFormFields.frequencyCapTime.min = 1;
        dv360DisplayFormFields.frequencyCapTime.max = 23;
      }
      if (type.includes('video')) {
        console.log('hello,*****************')
        dv360VideoFormFields.frequencyCapTime.min = 1;
        dv360VideoFormFields.frequencyCapTime.max = 23;
      }
    }
    if (perInterval == 1) {
      if (type.includes('display')) {
        console.log('hello,*****************')
        dv360DisplayFormFields.frequencyCapTime.min = 1;
        dv360DisplayFormFields.frequencyCapTime.max = 6;
      }
      if (type.includes('video')) {
        console.log('hello,*****************')
        dv360VideoFormFields.frequencyCapTime.min = 1;
        dv360VideoFormFields.frequencyCapTime.max = 6;
      }
    }
    if (perInterval == 2) {
      if (type.includes('display')) {
        console.log('hello,*****************')
        dv360DisplayFormFields.frequencyCapTime.min = 1;
        dv360DisplayFormFields.frequencyCapTime.max = 4;
      }
      if (type.includes('video')) {
        console.log('hello,*****************')
        dv360VideoFormFields.frequencyCapTime.min = 1;
        dv360VideoFormFields.frequencyCapTime.max = 4;
      }
    }
    if (perInterval == 3) {
      if (type.includes('display')) {
        console.log('hello,*****************')
        dv360DisplayFormFields.frequencyCapTime.min = 1;
        dv360DisplayFormFields.frequencyCapTime.max = 2;
      }
      if (type.includes('video')) {
        console.log('hello,*****************')
        dv360VideoFormFields.frequencyCapTime.min = 1;
        dv360VideoFormFields.frequencyCapTime.max = 2;
      }
    }
    if (perInterval == 4) {
      value = 1;
      if (type.includes('display')) {
        console.log('hello,*****************')
        dv360DisplayFormFields.frequencyCapTime.min = 1;
        dv360DisplayFormFields.frequencyCapTime.max = 1;
      }
      if (type.includes('video')) {
        console.log('hello,*****************')
        dv360VideoFormFields.frequencyCapTime.min = 1;
        dv360VideoFormFields.frequencyCapTime.max = 1;
      }
    }
    return value;
  };

  const handleChange = (e, key1, key2, formFields = {}) => {
    console.log("22 key", key1, key2)
    const { value, name } = e.target;
    let newValue = value;
    // setForm({ ...form, [name]: newValue });


    if (name == "frequencyCapPerInterval" && key1 == enumdataModal.dv360.key) {
      let dataFreqTime = calculateFrequencyCapTime(newValue, key2);
      setForm((prevForm) => ({
        ...prevForm,
        [key1]: {
          ...prevForm[key1],
          [key2]: {
            ...prevForm[key1][key2],
            form: {
              ...prevForm[key1][key2].form,
              frequencyCapTime: dataFreqTime,
            }
          },
        },
      }))
    }
    if (name == "startDate") {
      if (value > form[key1][key2].form.endDate) {
        setForm((prevForm) => ({
          ...prevForm,
          [key1]: {
            ...prevForm[key1],
            [key2]: {
              ...prevForm[key1][key2],
              form: {
                ...prevForm[key1][key2].form,
                endDate: '',
              }
            },
          },
        }))
      }
    }

    setForm((prevForm) => ({
      ...prevForm,
      [key1]: {
        ...prevForm[key1],
        [key2]: {
          ...prevForm[key1][key2],
          form: {
            ...prevForm[key1][key2].form,
            [name]: newValue,
          }
        },
      },
    })
    );
  };

  console.log(form);


  const setHighlight = (platform) => {
    setValidHighlight((prevValidHighlight) => ({
      ...prevValidHighlight,
      [platform]: true
    }));
  };

  const handleSaveAdWordsModal = async () => {

    setSubmited(true);

    let validSearch = true;
    let validDisplay = true;
    let validFreqDisplay = true;
    // let validCampaignName = true;
    let totalBudget = 0;
    const googleKey = enumdataModal.google.key;
    const googleSearchKey = enumdataModal.google.formType.search;
    const googleDisplayKey = enumdataModal.google.formType.display;
    // const googleCampaignKey = enumdataModal.google.campaign.campaignName;

    // if (true) {
    //   let { errors, valid } = handleError(form[googleKey][googleCampaignKey].form, adwordsFormFieldsCampaignName);
    //   if (!valid) {
    //     validCampaignName = false;
    //   }
    // }


    if (selectedModalAdType[enumdataModal.google.selectAdType.search]) {
      let { errors, valid } = handleError(form[googleKey][googleSearchKey].form, adwordsFormFields);
      if (!valid) {
        validSearch = false;
        await setErrorFormFields(googleKey, googleSearchKey, errors);
      }
      else {
        let data = form[googleKey][googleSearchKey].form;
        totalBudget = getBudgetUpdated(data, durationData);
      }
    }
    if (selectedModalAdType[enumdataModal.google.selectAdType.display]) {
      let { errors, valid } = handleError(form[googleKey][googleDisplayKey].form, adwordsDisplayFormFields);
      if (!valid) {
        validDisplay = false;
        await setErrorFormFields(googleKey, googleDisplayKey, errors);
      }
      else {
        let data = form[googleKey][googleDisplayKey].form;
        let budget = getBudgetUpdated(data, durationData);
        totalBudget = totalBudget + budget;
      }
      //For Frequency
      if (form[googleKey][googleDisplayKey].form.selectedFrequencyOption == "limited") {
        let formDataFreq = form[googleKey][googleDisplayKey].form;

        console.log("formDataFreq", formDataFreq)
        if (formDataFreq.frequencyCapForLevel && formDataFreq.frequencyCapTo && formDataFreq.frequencyCapPerInterval) {
          validFreqDisplay = true;
        }
        else {
          validFreqDisplay = false;
          message.error("Please Fill Frequency Capping Values")
        }
      }
    }

    if (validDisplay && validSearch && validFreqDisplay) {
      setTotalPlatformBudget({ ...totalPlatformBudget, google: totalBudget })
      setHighlight("google")
      setadwordsModal(false)
      callBackParent();
    }
  }

  const callBackParent = () => {
    console.log("123 callBackParent customDetailsForm", form)
    let propsData = {
      dataForm: window.structuredClone(form),
      adType: window.structuredClone(selectedModalAdType)
    }
    // props.setCustomDetailsForm(propsData)
    dispatch(
      customPlanReduxAction({
        customDetailsForm: propsData,
        // customPlanResponse: responseObj
      }))
  }

  const callBackParentSetResponse = (updatedForm, newSelectedModalAdTypeState) => {
    console.log("123 callBackParentSetResponse customDetailsForm", updatedForm);
    let propsData = {
      dataForm: window.structuredClone(updatedForm),
      adType: window.structuredClone(newSelectedModalAdTypeState)
    }
    dispatch(
      customPlanReduxAction({
        customDetailsForm: propsData,
        // customPlanResponse: responseObj
      }))
  }


  const toast = (status, msg, type) => {
    setEnableToast(true);
    setToastStatus(status);
    setToastMsg(msg);
    return;
  }

  const handleToastStatus = async (status) => {
    setEnableToast(status);
    // listCampaign();


  };

  const confirmationCallbackModel = () => {
    setEnableToast(false);

    // if (method === "recActiveStatus") {
    //   handleStatusUpdate();
    // }
  };

  const getBudgetUpdated = (data, durationDataParam) => {
    console.log("data", data)
    console.log("durationDataParam", durationDataParam)
    let budget = data.budget;
    const durationName = durationDataParam.find(item => item.id == data.duration);
    if (durationName) {
      const name = durationName.name;
      if (['lifetime','hourly'].includes(name.toLowerCase())) {
        const startDate = moment(data.startDate);
        const endDate = moment(data.endDate);
        const differenceInDays = endDate.diff(startDate, 'days') + 1;
        budget = parseInt(budget) / differenceInDays;
      }
    }
    return parseFloat(budget);
  }

  const setErrorFormFields = async (key1, key2, errors) => {
    setForm((prevForm) => ({
      ...prevForm,
      [key1]: {
        ...prevForm[key1],
        [key2]: {
          ...prevForm[key1][key2],
          errors: errors
        },
      },
    }))
  }

  const handleSaveFacebookModal = async () => {
    // Save the Facebook modal data similarly to AdWords
    // setFacebookModalData(form);
    // setfacebookModal(false);
    setSubmited(true)
    let validVideo = true;
    let validDisplay = true;
    let validCampaignName = true;
    let totalBudget = 0;
    const facebookKey = enumdataModal.facebook.key;
    const facebookVideoKey = enumdataModal.facebook.formType.video;
    const facebookDisplayKey = enumdataModal.facebook.formType.display;
    const facebookCampaignKey = enumdataModal.facebook.campaign.campaignName;


    if (true) {
      let { errors, valid } = handleError(form[facebookKey][facebookCampaignKey].form, facebookFormFieldsCampaignName);
      if (!valid) {
        validCampaignName = false;
      }
    }

    if (selectedModalAdType[enumdataModal.facebook.selectAdType.video]) {
      let { errors, valid } = handleError(form[facebookKey][facebookVideoKey].form, facebookVideoFormFields);
      if (!valid) {
        validVideo = false;
        await setErrorFormFields(facebookKey, facebookVideoKey, errors);
      }
      else {
        let data = form[facebookKey][facebookVideoKey].form;
        totalBudget = getBudgetUpdated(data, durationData);
      }
    }
    if (selectedModalAdType[enumdataModal.facebook.selectAdType.display]) {
      let { errors, valid } = handleError(form[facebookKey][facebookDisplayKey].form, facebookDisplayFormFields);
      if (!valid) {
        validDisplay = false;
        await setErrorFormFields(facebookKey, facebookDisplayKey, errors);
      }
      else {
        let data = form[facebookKey][facebookDisplayKey].form;
        let budget = getBudgetUpdated(data, durationData);
        totalBudget = totalBudget + budget;
      }
    }

    if (!validCampaignName) {
      setEnableToast(true);
      setToastMsg("Please Enter Campaign Name");
      setToastStatus("Fail");

    }

    else if (validCampaignName && validDisplay && validVideo) {

      setTotalPlatformBudget({ ...totalPlatformBudget, facebook: totalBudget })
      setHighlight("facebook")
      setfacebookModal(false)
      callBackParent();
    }
  };

  const handleSaveDV360Modal = async () => {

    setSubmited(true);

    let validVideo = true;
    let validDisplay = true;
    let validCampaignName = true;
    let validFreqVideo = true;
    let validFreqDisplay = true;
    let totalBudget = 0;
    const dv360Key = enumdataModal.dv360.key;
    const dv360VideoKey = enumdataModal.dv360.formType.video;
    const dv360DisplayKey = enumdataModal.dv360.formType.display;
    const dv360CampaignKey = enumdataModal.dv360.campaign.campaignName;

    if (true) {
      let { errors, valid } = handleError(form[dv360Key][dv360CampaignKey].form, dv360FormFieldsCampaignName);
      if (!valid) {
        validCampaignName = false;
      }
    }


    if (selectedModalAdType[enumdataModal.dv360.selectAdType.video]) {
      let { errors, valid } = handleError(form[dv360Key][dv360VideoKey].form, dv360VideoFormFields);
      if (!valid) {
        validVideo = false;
        await setErrorFormFields(dv360Key, dv360VideoKey, errors);
      }
      else {
        let data = form[dv360Key][dv360VideoKey].form;
        totalBudget = getBudgetUpdated(data, durationData);
      }
      //For Frequency
      if (form[dv360Key][dv360VideoKey].form.selectedFrequencyOption == "limited") {
        let formDataFreq = form[dv360Key][dv360VideoKey].form;

        console.log("formDataFreq", formDataFreq)
        if (formDataFreq.frequencyCapTime && formDataFreq.frequencyCapTo && formDataFreq.frequencyCapPerInterval) {
          validFreqVideo = true;
        }
        else {
          validFreqVideo = false;
          message.error("Please Fill Frequency Capping Values")
        }
      }


    }
    if (selectedModalAdType[enumdataModal.dv360.selectAdType.display]) {
      let { errors, valid } = handleError(form[dv360Key][dv360DisplayKey].form, dv360DisplayFormFields);
      if (!valid) {
        validDisplay = false;
        await setErrorFormFields(dv360Key, dv360DisplayKey, errors);
      }
      else {
        let data = form[dv360Key][dv360DisplayKey].form;
        let budget = getBudgetUpdated(data, durationData);
        totalBudget = totalBudget + budget;
      }
      //For Frequency
      if (form[dv360Key][dv360DisplayKey].form.selectedFrequencyOption == "limited") {
        let formDataFreq = form[dv360Key][dv360DisplayKey].form;

        console.log("formDataFreq", formDataFreq)
        if (formDataFreq.frequencyCapTime && formDataFreq.frequencyCapTo && formDataFreq.frequencyCapPerInterval) {
          validFreqDisplay = true;
        }
        else {
          validFreqDisplay = false;
          message.error("Please Fill Frequency Capping Values")
        }
      }
    }

    if (!validCampaignName) {
      setEnableToast(true);
      setToastMsg("Please Enter Campaign Name");
      setToastStatus("Fail");

    }

    else if (validCampaignName && validDisplay && validVideo && validFreqDisplay && validFreqVideo) {

      setTotalPlatformBudget({ ...totalPlatformBudget, dv360: totalBudget })
      setHighlight("dv360")
      setdv360Modal(false)
      callBackParent();
    }
  }

  const handleSaveTikTokModal = async () => {
    // Save the tiktok modal data similarly to AdWords
    // settiktokModalData(form);
    // settiktokModal(false);
    setSubmited(true)
    let validVideo = true;
    let validDisplay = true;
    let validCampaignName = true;
    let totalBudget = 0;
    const tiktokKey = enumdataModal.tiktok.key;
    const tiktokVideoKey = enumdataModal.tiktok.formType.video;
    const tiktokDisplayKey = enumdataModal.tiktok.formType.display;
    const tiktokCampaignKey = enumdataModal.tiktok.campaign.campaignName;


    if (true) {
      let { errors, valid } = handleError(form[tiktokKey][tiktokCampaignKey].form, tiktokFormFieldsCampaignName);
      if (!valid) {
        validCampaignName = false;
      }
    }

    if (selectedModalAdType[enumdataModal.tiktok.selectAdType.video]) {
      let { errors, valid } = handleError(form[tiktokKey][tiktokVideoKey].form, tiktokVideoFormFields);
      if (!valid) {
        validVideo = false;
        await setErrorFormFields(tiktokKey, tiktokVideoKey, errors);
      }
      else {
        let data = form[tiktokKey][tiktokVideoKey].form;
        totalBudget = getBudgetUpdated(data, durationData);
      }
    }

    if (!validCampaignName) {
      setEnableToast(true);
      setToastMsg("Please Enter Campaign Name");
      setToastStatus("Fail");

    }

    else if (validCampaignName && validDisplay && validVideo) {

      setTotalPlatformBudget({ ...totalPlatformBudget, tiktok: totalBudget })
      setHighlight("tiktok")
      settiktokModal(false)
      callBackParent();
    }
  };

  const handleSaveIonModal = async () => {
    console.log("handleSaveIonModal")
    setSubmited(true)
    let validVideo = true;
    let validDisplay = true;
    let validFreqVideo = true;
    let validFreqDisplay = true;
    let totalBudget = 0;
    const ionKey = enumdataModal.ion.key;
    const ionVideoKey = enumdataModal.ion.formType.video;
    const ionDisplayKey = enumdataModal.ion.formType.display;

    if (selectedModalAdType[enumdataModal.ion.selectAdType.video]) {
      console.log("video validDisplayION", validDisplay);
      console.log("video validVideo", validVideo);
      let { errors, valid } = handleError(form[ionKey][ionVideoKey].form, ionVideoFormFields);
      console.log("valid", valid)
      console.log("errors", errors)
      if (!valid) {
        validVideo = false;
        await setErrorFormFields(ionKey, ionVideoKey, errors);
      }
      else {
        let data = form[ionKey][ionVideoKey].form;
        totalBudget = getBudgetUpdated(data, durationData);
      }
      //For Frequency
      if (form[ionKey][ionVideoKey].form.selectedFrequencyOption == "limited") {
        let formDataFreq = form[ionKey][ionVideoKey].form;

        console.log("formDataFreq", formDataFreq)
        if (formDataFreq.frequencyCapTo && formDataFreq.frequencyCapPerInterval) {
          validFreqVideo = true;
        }
        else {
          validFreqVideo = false;
          message.error("Please Fill Frequency Capping Values")
        }
      }
    }
    if (selectedModalAdType[enumdataModal.ion.selectAdType.display]) {
      console.log("display validDisplayION", validDisplay);
      console.log("display validVideo", validVideo);
      let { errors, valid } = handleError(form[ionKey][ionDisplayKey].form, ionDisplayFormFields);
      console.log("valid", valid)
      console.log("errors", errors)

      if (!valid) {
        validDisplay = false;
        await setErrorFormFields(ionKey, ionDisplayKey, errors);
      }

      else {
        console.log("display validDisplayION", validDisplay);
        console.log("display validVideo", validVideo);
        let data = form[ionKey][ionDisplayKey].form;
        let budget = getBudgetUpdated(data, durationData);
        totalBudget = totalBudget + budget;
      }
      //For Frequency
      if (form[ionKey][ionDisplayKey].form.selectedFrequencyOption == "limited") {
        let formDataFreq = form[ionKey][ionDisplayKey].form;

        console.log("formDataFreq", formDataFreq)
        if (formDataFreq.frequencyCapTo && formDataFreq.frequencyCapPerInterval) {
          validFreqDisplay = true;
        }
        else {
          validFreqDisplay = false;
          message.error("Please Fill Frequency Capping Values")
        }
      }
    }

    if (validDisplay && validVideo && validFreqDisplay && validFreqVideo) {
      console.log("validDisplay && validVideo validDisplayION", validDisplay);
      console.log("validDisplay && validVideo validVideo", validVideo);

      setTotalPlatformBudget({ ...totalPlatformBudget, ion: totalBudget })
      setHighlight("ion")
      setionModal(false)
      callBackParent();
    }
  };

  const handleSaveViAdsModal = async () => {
    setSubmited(true)
    let validVideo = true;
    let validDisplay = true;
    let validFreqVideo = true;
    let validFreqDisplay = true;
    let totalBudget = 0;
    const viadsKey = enumdataModal.viads.key;
    const viadsVideoKey = enumdataModal.viads.formType.video;
    const viadsDisplayKey = enumdataModal.viads.formType.display;

    if (selectedModalAdType[enumdataModal.viads.selectAdType.video]) {
      // console.log("video validDisplayION", validDisplay);
      // console.log("video validVideo", validVideo);
      let { errors, valid } = handleError(form[viadsKey][viadsVideoKey].form, viAdsVideoFormFields);
      // console.log("valid", valid)
      // console.log("errors", errors)
      if (!valid) {
        validVideo = false;
        await setErrorFormFields(viadsKey, viadsVideoKey, errors);
      }
      else {
        let data = form[viadsKey][viadsVideoKey].form;
        totalBudget = getBudgetUpdated(data, durationData);
      }
        //For Frequency
        if (form[viadsKey][viadsVideoKey].form.selectedFrequencyOption == "limited") {
          let formDataFreq = form[viadsKey][viadsVideoKey].form;
  
          if (formDataFreq.frequencyCapTo && formDataFreq.frequencyCapPerInterval) {
            validFreqVideo = true;
          }
          else {
            validFreqVideo = false;
            message.error("Please Fill Frequency Capping Values")
          }
        }
    }
    if (selectedModalAdType[enumdataModal.viads.selectAdType.display]) {
      // console.log("display validDisplayION", validDisplay);
      // console.log("display validVideo", validVideo);
      let { errors, valid } = handleError(form[viadsKey][viadsDisplayKey].form, viAdsDisplayFormFields);
      // console.log("valid", valid)
      // console.log("errors", errors)

      if (!valid) {
        validDisplay = false;
        await setErrorFormFields(viadsKey, viadsDisplayKey, errors);
      }

      else {
        // console.log("display validDisplayION", validDisplay);
        // console.log("display validVideo", validVideo);
        let data = form[viadsKey][viadsDisplayKey].form;
        let budget = getBudgetUpdated(data, durationData);
        totalBudget = totalBudget + budget;
      }

       //For Frequency
       if (form[viadsKey][viadsDisplayKey].form.selectedFrequencyOption == "limited") {
        let formDataFreq = form[viadsKey][viadsDisplayKey].form;

        if (formDataFreq.frequencyCapTo && formDataFreq.frequencyCapPerInterval) {
          validFreqDisplay = true;
        }
        else {
          validFreqDisplay = false;
          message.error("Please Fill Frequency Capping Values")
        }
      }
    }

    if (validDisplay && validVideo && validFreqDisplay && validFreqVideo) {
      // console.log("validDisplay && validVideo validDisplayION", validDisplay);
      // console.log("validDisplay && validVideo validVideo", validVideo);

      setTotalPlatformBudget({ ...totalPlatformBudget, viads: totalBudget })
      setHighlight("viads")
      setViadsModal(false)
      callBackParent();
    }
  };

  const selectAdType = (type) => {
    const googleKey = enumdataModal.google.key;
    const ionKey = enumdataModal.ion.key;
    const viKey = enumdataModal.viads.key;
    const googleSearchKey = enumdataModal.google.formType.search;
    const googleDisplayKey = enumdataModal.google.formType.display;
    const ionDisplayKey = enumdataModal.ion.formType.display;
    const ionVideoKey = enumdataModal.ion.formType.video;
    const viDisplayKey = enumdataModal.viads.formType.display;
    const viVideoKey = enumdataModal.viads.formType.video;
    setSelectedModalAdType({ ...selectedModalAdType, [type]: !selectedModalAdType[type] })
    if (type == enumdataModal.google.selectAdType.search) {
      setErrorFormFields(googleKey, googleSearchKey, {});
    }
    else if (type == enumdataModal.google.selectAdType.display) {
      setErrorFormFields(googleKey, googleDisplayKey, {});
    }
    else if (type == enumdataModal.ion.selectAdType.display) {
      setErrorFormFields(ionKey, ionDisplayKey, {});
    }
    else if (type == enumdataModal.ion.selectAdType.video) {
      setErrorFormFields(ionKey, ionVideoKey, {});
    }
    else if (type == enumdataModal.viads.selectAdType.display) {
      setErrorFormFields(viKey, viDisplayKey, {});
    }
    else if (type == enumdataModal.viads.selectAdType.video) {
      setErrorFormFields(viKey, viVideoKey, {});
    }
  }
  const currency = JSON.parse(localStorage.getItem('currency'));


  const handleClickModal = (platform) => () => {

    console.log("platform", platform);
    console.log("platformData", platformData);
    console.log("dataConfig", dataConfig)
    // Check if dataConfig is defined and is an array
    if (Array.isArray(dataConfig)) {
      const findPlatform = platformData.find((data) => data.value.toLowerCase().includes(platform.toLowerCase()));
      let pacingPlatformData = dataConfig.filter(item => (item.platformId == findPlatform.key && item.name == "Pacing_Type"));
      let durationPlatformData = dataConfig.filter(item => (item.platformId == findPlatform.key && item.name == "Duration_Type"));
      if (pacingPlatformData && pacingPlatformData[0] && pacingPlatformData[0].hasOwnProperty('list')) {
        setPacingData(pacingPlatformData[0].list);
      } else {
        setPacingData([]);
      }
      if (durationPlatformData && durationPlatformData[0] && durationPlatformData[0].hasOwnProperty('list')) {
        setDurationData(durationPlatformData[0].list);
      } else {
        setDurationData([]);
      }
      // Toggle the modal state based on the platform
      switch (platform) {
        case 'ads':
          setadwordsModal(!adwordsModal);
          break;
        case 'meta':
          setfacebookModal(!facebookModal);
          break;
        case 'dv360':
          setdv360Modal(!dv360Modal);
          break;
        case 'tiktok':
          settiktokModal(!tiktokModal);
          break;
        case 'ion':
          setionModal(!ionModal)
          break;
        case 'viads':
            setViadsModal(!viAdsModal)
            break;
        // Add cases for other platforms as needed

        default:
        // Default case, if the platform doesn't match any specific case
      }
    } else {
      console.error("dataConfig is not defined or is not an array");
    }
  };

  // console.log(basicDetailsForm, 'BASIC DETAILS FORM');
  console.log(customPlanData, 'CUSTOM PLAN DATA');


  const handleAddFormClick = (formKey, setShowForm) => {
    setShowForm((prevShowForm) => !prevShowForm);
  };



  return (
    <div>
      {
        enableToast && <ToastModal
          enableToast={enableToast}
          status={toastStatus}
          msg={toastMsg}
          // path={routes.containers.admin + '/' + routes.admin.account.name}
          idProps={props}
          handleConfirmation={confirmationCallbackModel}
          handleToastStatus={handleToastStatus}
          confirmationMsg={confirmationMsg}
          poc={true}
          outSideClickEnable={false}
        />
      }
      <div style={{ color: "#394256" }}>Create custom plan</div>

      <div className="platforms">
        {/* <div className={`platform ${validHighlight.google ? 'highlight' : ''}`} onClick={() => setadwordsModal(!adwordsModal)} > */}
        <div className={`platform ${validHighlight.google ? 'highlight' : ''}`} onClick={handleClickModal('ads')} >
          <div className='d-flex align-items-center'>
            {/* <input
              type="checkbox"
              checked={showGoogleAdWordsModal}
              onChange={handleGoogleAdWordsCheckboxClick}
            /> */}
            <img style={{ margin: "0 8px" }} src={adwords} alt="adwords" />
            <div className='checkbox-title'>Google AdWords</div>
          </div>
          <div className='d-flex align-items-center'>
            <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Available Media</h6>
              <p style={{ fontSize: 12 }}>Search, Display</p>
            </div>

            {validHighlight.google ? (
              <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                <h6 style={{ fontSize: 11 }}>Selected Media</h6>
                <p style={{ fontSize: 12 }}>
                  <i className='fa fa-check-circle text-success mr-1'></i>
                  {`${selectedModalAdType[enumdataModal.google.selectAdType.search] ? 'Search' : ''}${selectedModalAdType[enumdataModal.google.selectAdType.search] && selectedModalAdType[enumdataModal.google.selectAdType.display] ? ', ' : ''}${selectedModalAdType[enumdataModal.google.selectAdType.display] ? 'Display' : ''}`}
                </p>
              </div>
            ) : null}


            <div><span style={{ color: "#1B2559", fontSize: 20, fontWeight: 600 }}> {currency ? currency.value : ''} {totalPlatformBudget.google.toFixed(2)} </span> / day</div>
            {validHighlight.google ? (
              <i className="ti ti-pencil text-primary ml-2"></i>
            ) : null}
          </div>
        </div>

        {/* <div className={`platform ${validHighlight.facebook ? 'highlight' : ''}`} onClick={() => setfacebookModal(!facebookModal)} > */}
        <div className={`platform ${validHighlight.facebook ? 'highlight' : ''}`} onClick={handleClickModal('meta')} >
          <div className='d-flex align-items-center'>
            {/* <input
              type="checkbox"
              checked={showFacebookModal}
              onChange={handleFacebookCheckboxClick}
            /> */}
            <img style={{ margin: "0 12px" }} src={meta} alt="meta" />
            <div className='checkbox-title'>Meta</div>
          </div>
          <div className='d-flex align-items-center'>
            <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Available Media</h6>
              <p style={{ fontSize: 12 }}>Display, Video</p>
            </div>

            {/* <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Selected Media</h6>
              <p style={{ fontSize: 12 }}>
                <i className='fa fa-check-circle text-success mr-1'></i>
                Display, Video</p>
            </div> */}

            {validHighlight.facebook ? (
              <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                <h6 style={{ fontSize: 11 }}>Selected Media</h6>
                <p style={{ fontSize: 12 }}>
                  <i className='fa fa-check-circle text-success mr-1'></i>
                  {`${selectedModalAdType[enumdataModal.facebook.selectAdType.display] ? 'Display' : ''}${selectedModalAdType[enumdataModal.facebook.selectAdType.display] && selectedModalAdType[enumdataModal.facebook.selectAdType.video] ? ', ' : ''}${selectedModalAdType[enumdataModal.facebook.selectAdType.video] ? 'Video' : ''}`}
                </p>
              </div>
            ) : null}

            <div><span style={{ color: "#1B2559", fontSize: 20, fontWeight: 600 }}> {currency ? currency.value : ''} {totalPlatformBudget.facebook.toFixed(2)} </span> / day</div>
            {validHighlight.facebook ? (
              <i className="ti ti-pencil text-primary ml-2"></i>
            ) : null}
          </div>
        </div>

        {/* <div className={`platform ${validHighlight.dv360 ? 'highlight' : ''}`} onClick={() => setdv360Modal(!dv360Modal)}> */}
        <div className={`platform ${validHighlight.dv360 ? 'highlight' : ''}`} onClick={handleClickModal('dv360')} >
          <div className='d-flex align-items-center'>
            {/* <input
              type="checkbox"
              checked={showDV360Modal}
              onChange={handleDV360CheckboxClick}
            /> */}
            <img style={{ margin: "0 14px" }} src={dv360} alt="dv360" />
            <div className='checkbox-title'>DV360</div>
          </div>
          <div className='d-flex align-items-center'>
            <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Available Media</h6>
              <p style={{ fontSize: 12 }}>Video, Display</p>
            </div>

            {validHighlight.dv360 ? (
              <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                <h6 style={{ fontSize: 11 }}>Selected Media</h6>
                <p style={{ fontSize: 12 }}>
                  <i className='fa fa-check-circle text-success mr-1'></i>
                  {`${selectedModalAdType[enumdataModal.dv360.selectAdType.video] ? 'Video' : ''}${selectedModalAdType[enumdataModal.dv360.selectAdType.video] && selectedModalAdType[enumdataModal.dv360.selectAdType.display] ? ', ' : ''}${selectedModalAdType[enumdataModal.dv360.selectAdType.display] ? 'Display' : ''}`}
                </p>
              </div>
            ) : null}

            <div><span style={{ color: "#1B2559", fontSize: 20, fontWeight: 600 }}> {currency ? currency.value : ''} {totalPlatformBudget.dv360.toFixed(2)} </span> / day</div>
            {validHighlight.dv360 ? (
              <i className="ti ti-pencil text-primary ml-2"></i>
            ) : null}
          </div>
        </div>

        {/* <div className={`platform ${validHighlight.tiktok ? 'highlight' : ''}`} onClick={() => settiktokModal(!tiktokModal)}> */}
        <div className={`platform ${validHighlight.tiktok ? 'highlight' : ''}`} onClick={handleClickModal('tiktok')} >
          <div className='d-flex align-items-center'>
            {/* <input
              type="checkbox"
              checked={showTikTokModal}
              onChange={handleTikTokCheckboxClick}
            /> */}
            <img style={{ margin: "0 8px" }} src={tiktok} alt="tiktok" />
            <div className='checkbox-title'>TikTok</div>
          </div>
          <div className='d-flex align-items-center'>
            <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Available Media</h6>
              <p style={{ fontSize: 12 }}>Video</p>
            </div>

            {validHighlight.tiktok ? (
              <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                <h6 style={{ fontSize: 11 }}>Selected Media</h6>
                <p style={{ fontSize: 12 }}>
                  <i className='fa fa-check-circle text-success mr-1'></i>
                  {`${selectedModalAdType[enumdataModal.tiktok.selectAdType.video] ? 'Video' : ''}`}
                </p>
              </div>
            ) : null}

            <div><span style={{ color: "#1B2559", fontSize: 20, fontWeight: 600 }}> {currency ? currency.value : ''} {totalPlatformBudget.tiktok.toFixed(2)} </span> / day</div>
            {validHighlight.tiktok ? (
              <i className="ti ti-pencil text-primary ml-2"></i>
            ) : null}
          </div>
        </div>

        {/* <div className={`platform ${validHighlight.ion ? 'highlight' : ''}`} onClick={() => setionModal(!ionModal)} > */}
        <div className={`platform ${validHighlight.ion ? 'highlight' : ''}`} onClick={handleClickModal('ion')} >
          <div className='d-flex align-items-center'>
            <img style={{ margin: "0 12px", height: 30 }} src={ion} alt="ion" />
            <div className='checkbox-title'>ION</div>
          </div>
          <div className='d-flex align-items-center'>
            <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Available Media</h6>
              <p style={{ fontSize: 12 }}>Display, Video</p>
            </div>

            {/* <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Selected Media</h6>
              <p style={{ fontSize: 12 }}>
                <i className='fa fa-check-circle text-success mr-1'></i>
                Display, Video</p>
            </div> */}

            {validHighlight.ion ? (
              <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                <h6 style={{ fontSize: 11 }}>Selected Media</h6>
                <p style={{ fontSize: 12 }}>
                  <i className='fa fa-check-circle text-success mr-1'></i>
                  {`${selectedModalAdType[enumdataModal.ion.selectAdType.display] ? 'Display' : ''}${selectedModalAdType[enumdataModal.ion.selectAdType.display] && selectedModalAdType[enumdataModal.ion.selectAdType.video] ? ', ' : ''}${selectedModalAdType[enumdataModal.ion.selectAdType.video] ? 'Video' : ''}`}
                </p>
              </div>
            ) : null}

            <div><span style={{ color: "#1B2559", fontSize: 20, fontWeight: 600 }}> {currency ? currency.value : ''} {totalPlatformBudget.ion.toFixed(2)} </span> / day</div>
            {validHighlight.ion ? (
              <i className="ti ti-pencil text-primary ml-2"></i>
            ) : null}
          </div>
        </div>

        <div className={`platform ${validHighlight.viads ? 'highlight' : ''}`} onClick={handleClickModal('viads')} >
          <div className='d-flex align-items-center'>
            <img style={{ margin: "0 12px", height: 30 }} src={ViLogo} alt="ion" />
            <div className='checkbox-title'>viads</div>
          </div>
          <div className='d-flex align-items-center'>
            <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Available Media</h6>
              <p style={{ fontSize: 12 }}>Display, Video</p>
            </div>

            {/* <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
              <h6 style={{ fontSize: 11 }}>Selected Media</h6>
              <p style={{ fontSize: 12 }}>
                <i className='fa fa-check-circle text-success mr-1'></i>
                Display, Video</p>
            </div> */}

            {validHighlight.viads ? (
              <div className='d-flex flex-column' style={{ paddingRight: "4em" }}>
                <h6 style={{ fontSize: 11 }}>Selected Media</h6>
                <p style={{ fontSize: 12 }}>
                  <i className='fa fa-check-circle text-success mr-1'></i>
                  {`${selectedModalAdType[enumdataModal.viads.selectAdType.display] ? 'Display' : ''}${selectedModalAdType[enumdataModal.viads.selectAdType.display] && selectedModalAdType[enumdataModal.viads.selectAdType.video] ? ', ' : ''}${selectedModalAdType[enumdataModal.viads.selectAdType.video] ? 'Video' : ''}`}
                </p>
              </div>
            ) : null}

            <div><span style={{ color: "#1B2559", fontSize: 20, fontWeight: 600 }}> {currency ? currency.value : ''} {totalPlatformBudget.viads.toFixed(2)} </span> / day</div>
            {validHighlight.viads ? (
              <i className="ti ti-pencil text-primary ml-2"></i>
            ) : null}
          </div>
        </div>
      </div>

      <Modal open={adwordsModal} size="medium" className='modal-center-adj'>
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header" style={{ alignItems: "center", background: "#F7F8FC" }}>
            <h5 className="modal-title" style={{ margin: "0 auto", color: "#040B1B", fontSize: 24 }}>Add Details for Google Adwords</h5>
            <button type="button" onClick={() => setadwordsModal(!adwordsModal)} className="close" data-dismiss="modal" aria-label="Close">
              <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">x</span></div>
            </button>
          </div>
          <div className='modal-body inputUI' style={{ height: "70vh", overflowY: "scroll" }} >
            <div className='row p-3 px-4'>
              {/* <div className="col-md-12">
                <Input
                  onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.campaign.campaignName) }}
                  onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.campaign.campaignName, adwordsFormFieldsCampaignName) }}
                  value={form[enumdataModal.google.key][enumdataModal.google.campaign.campaignName].form[adwordsFormFieldsCampaignName.campaignName.key] || ''}
                  setting={adwordsFormFieldsCampaignName[adwordsFormFieldsCampaignName.campaignName.key]}
                  error={form[enumdataModal.google.key][enumdataModal.google.campaign.campaignName].errors[adwordsFormFieldsCampaignName.campaignName.key]}
                  submited={submited}
                  touched={form[enumdataModal.google.key][enumdataModal.google.campaign.campaignName].touched[adwordsFormFieldsCampaignName.campaignName.key]}
                // disabled={!selectedModalAdType[enumdataModal.google.selectAdType.search]}
                />
              </div> */}

              <div title={`${selectedModalAdType[enumdataModal.google.selectAdType.search] ? 'Click here deselect' : 'Click here select'}`} className={`col-adj p-4 ${selectedModalAdType[enumdataModal.google.selectAdType.search] ? 'highlightType' : ''}`} style={{ borderRadius: 10 }} onClick={() => selectAdType(enumdataModal.google.selectAdType.search)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Search Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Camp. Name<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.search) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.search, adwordsFormFields) }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.search].form[adwordsFormFields.campaignName.key] || ''}
                        setting={adwordsFormFields[adwordsFormFields.campaignName.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.search].errors[adwordsFormFields.campaignName.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.search].touched[adwordsFormFields.campaignName.key]}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.search]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.search) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.search, adwordsFormFields) }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.search].form[adwordsFormFields.budget.key] || ''}
                        setting={adwordsFormFields[adwordsFormFields.budget.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.search].errors[adwordsFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.search].touched[adwordsFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.search]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.search) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.search, adwordsFormFields) }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.search].form[adwordsFormFields.pacing.key]}
                        setting={adwordsFormFields[adwordsFormFields.pacing.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.search].errors[adwordsFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.search].touched[adwordsFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.search]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.search) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.search, adwordsFormFields) }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.search].form[adwordsFormFields.duration.key]}
                        setting={adwordsFormFields[adwordsFormFields.duration.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.search].errors[adwordsFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.search].touched[adwordsFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.search]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.search, adwordsFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.google.key,enumdataModal.google.formType.search)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.search].form[adwordsFormFields.startDate.key] || ''}
                        setting={adwordsFormFields[adwordsFormFields.startDate.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.search].errors[adwordsFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.search].touched[adwordsFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.search]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.search, adwordsFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.google.key,enumdataModal.google.formType.search)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.search].form[adwordsFormFields.endDate.key] || ''}
                        setting={adwordsFormFields[adwordsFormFields.endDate.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.search].errors[adwordsFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.search].touched[adwordsFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        // minDate={new Date()}
                        minDate={form[enumdataModal.google.key][enumdataModal.google.formType.search].form[adwordsFormFields.startDate.key] ? form[enumdataModal.google.key][enumdataModal.google.formType.search].form[adwordsFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.search]}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.google.selectAdType.display] ? 'highlightType' : ''}`} style={{ borderRadius: 10, position: "relative" }} onClick={() => selectAdType(enumdataModal.google.selectAdType.display)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Display Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Camp. Name<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.campaignName.key] || ''}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.campaignName.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.campaignName.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.campaignName.key]}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}
                      />
                    </div>
                  </div>


                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      {/* <Input
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[adwordsDisplayFormFields.budget.key]}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.budget.key]}
                        error={errors[adwordsDisplayFormFields.budget.key]}
                        submited={submited}
                        touched={touched[adwordsDisplayFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}
                      /> */}
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.budget.key] || ''}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.budget.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.pacing.key] || ''}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.pacing.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      {/* <SelectNew
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[adwordsDisplayFormFields.duration.key]}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.duration.key]}
                        error={errors[adwordsDisplayFormFields.duration.key]}
                        submited={submited}
                        touched={touched[adwordsDisplayFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}
                      /> */}
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.duration.key] || ''}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.duration.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      {/* <Datepicker
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[adwordsDisplayFormFields.startDate.key] || ''}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.startDate.key]}
                        error={errors[adwordsDisplayFormFields.startDate.key]}
                        submited={submited}
                        touched={touched[adwordsDisplayFormFields.startDate.key]}
                        minDate={new Date()}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}

                      /> */}
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.google.key,enumdataModal.google.formType.search)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.startDate.key] || ''}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.startDate.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      {/* <Datepicker
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[adwordsDisplayFormFields.endDate.key] || ''}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.endDate.key]}
                        error={errors[adwordsDisplayFormFields.endDate.key]}
                        submited={submited}
                        touched={touched[adwordsDisplayFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={new Date()}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}

                      /> */}
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                        onBlur={() => { }}
                        value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.endDate.key] || ''}
                        setting={adwordsDisplayFormFields[adwordsDisplayFormFields.endDate.key]}
                        error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.startDate.key] ? form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display]}
                      />


                    </div>
                  </div>

                  <CSSTransition
                    in={showFrequencyForm.googleDisplay}
                    timeout={300}
                    classNames="form-transition"
                    unmountOnExit
                  >
                    {/* {showFrequencyForm.googleDisplay && */}
                    <div>
                      <div class="col-md-12 px-0 pb-2" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Frequency Management</label></div>

                      <div className="col d-flex align-items-center pb-3 px-0">
                        <div className="d-flex align-items-center pr-4">
                          <input
                            type="radio"
                            id="none_frequencyCapGoogleDisplay"
                            name="frequencyCapGoogleDisplay"
                            value="none"
                            checked={form[enumdataModal.google.key][enumdataModal.google.formType.display].form.selectedFrequencyOption === "none"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "none" } }, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                          />
                          <label htmlFor="none_frequencyCapGoogleDisplay" className="mb-0 pl-2">
                            None
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="limited_frequencyCapGoogleDisplay"
                            name="frequencyCapGoogleDisplay"
                            value="limited"
                            checked={form[enumdataModal.google.key][enumdataModal.google.formType.display].form.selectedFrequencyOption === "limited"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "limited" } }, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                          />
                          <label htmlFor="limited_frequencyCapGoogleDisplay" className="mb-0 pl-2">
                            Limited
                          </label>
                        </div>
                      </div>


                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Set Impressions for</label></div>
                        <div class="col-md-8 pr-0">
                          <SelectNew
                            onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                            value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.frequencyCapForLevel.key] || ''}
                            setting={adwordsDisplayFormFields[adwordsDisplayFormFields.frequencyCapForLevel.key]}
                            error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.frequencyCapForLevel.key]}
                            submited={submited}
                            touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.frequencyCapForLevel.key]}
                            options={[{ id: 1, name: 'The whole campaign' },
                            { id: 2, name: 'Each adgroup' },
                            { id: 3, name: 'Each ad' }]}
                            disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display] || form[enumdataModal.google.key][enumdataModal.google.formType.display].form.selectedFrequencyOption === "none"}
                          />
                        </div>
                      </div>

                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>To</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                            value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.frequencyCapTo.key] || ''}
                            setting={adwordsDisplayFormFields[adwordsDisplayFormFields.frequencyCapTo.key]}
                            error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.frequencyCapTo.key]}
                            submited={submited}
                            touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.frequencyCapTo.key]}
                            disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display] || form[enumdataModal.google.key][enumdataModal.google.formType.display].form.selectedFrequencyOption === "none"}
                          />
                        </div>
                      </div>


                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
                        <div class="col-md-8 pr-0">
                          <SelectNew
                            onChange={(e) => { handleChange(e, enumdataModal.google.key, enumdataModal.google.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.google.key, enumdataModal.google.formType.display, adwordsDisplayFormFields) }}
                            value={form[enumdataModal.google.key][enumdataModal.google.formType.display].form[adwordsDisplayFormFields.frequencyCapPerInterval.key] || ''}
                            setting={adwordsDisplayFormFields[adwordsDisplayFormFields.frequencyCapPerInterval.key]}
                            error={form[enumdataModal.google.key][enumdataModal.google.formType.display].errors[adwordsDisplayFormFields.frequencyCapPerInterval.key]}
                            submited={submited}
                            touched={form[enumdataModal.google.key][enumdataModal.google.formType.display].touched[adwordsDisplayFormFields.frequencyCapPerInterval.key]}
                            options={[{ id: 1, name: 'Day' },
                            { id: 2, name: 'Week' },
                            { id: 3, name: 'Month' }]}
                            disabled={!selectedModalAdType[enumdataModal.google.selectAdType.display] || form[enumdataModal.google.key][enumdataModal.google.formType.display].form.selectedFrequencyOption === "none"}
                          />
                        </div>
                      </div>
                    </div>
                    {/* } */}
                  </CSSTransition>

                </div>
                <div className="strategy-bottom-bar border p-2 mx-n4 mb-n4"
                  style={{
                    position: "absolute",
                    right: 24,
                    left: 24,
                    bottom: 24,
                  }}
                  onClick={(e) => { e.stopPropagation() }}>
                  <CSSTransition
                    in={!showFrequencyForm.googleDisplay}
                    timeout={{ enter: 300, exit: 200 }}
                    classNames="button-transition"
                    unmountOnExit
                  >
                    <div
                      onClick={() => setShowFrequencyForm({ ...showFrequencyForm, googleDisplay: !showFrequencyForm.googleDisplay })}
                    >
                      Frequency Capping
                    </div>
                  </CSSTransition>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 justify-content-end d-flex p-4" style={{ background: "#F7F8FC" }}>
            <button onClick={() => setadwordsModal(!adwordsModal)} className="btn btn-outline-primary">Cancel</button>
            <button onClick={handleSaveAdWordsModal} disabled={!selectedModalAdType[enumdataModal.google.selectAdType.search] && !selectedModalAdType[enumdataModal.google.selectAdType.display]} className="btn btn-primary bg-color-beki ml-3">Save</button>
          </div>
        </div>
      </Modal>

      <Modal open={facebookModal} size="medium" className='modal-center-adj'>
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header">
            <h5 className="modal-title" style={{ margin: "0 auto", color: "#040B1B" }}>Add Details for Meta</h5>
            <button type="button" onClick={() => setfacebookModal(!facebookModal)} className="close" data-dismiss="modal" aria-label="Close">
              <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">x</span></div>
            </button>
          </div>
          <div className='modal-body inputUI' style={{ height: "70vh", overflowY: "scroll" }} >
            <div className='row p-3 px-4'>
              <div className="col-md-12">
                <Input
                  onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.campaign.campaignName) }}
                  onBlur={(e) => { handleTouch(e, enumdataModal.facebook.key, enumdataModal.facebook.campaign.campaignName, facebookFormFieldsCampaignName) }}
                  value={form[enumdataModal.facebook.key][enumdataModal.facebook.campaign.campaignName].form[facebookFormFieldsCampaignName.campaignName.key] || ''}
                  setting={facebookFormFieldsCampaignName[facebookFormFieldsCampaignName.campaignName.key]}
                  error={form[enumdataModal.facebook.key][enumdataModal.facebook.campaign.campaignName].errors[facebookFormFieldsCampaignName.campaignName.key]}
                  submited={submited}
                  touched={form[enumdataModal.facebook.key][enumdataModal.facebook.campaign.campaignName].touched[facebookFormFieldsCampaignName.campaignName.key]}
                // disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.search]}
                />
              </div>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.facebook.selectAdType.display] ? 'highlightType' : ''}`} style={{ borderRadius: 10 }} onClick={() => selectAdType(enumdataModal.facebook.selectAdType.display)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Display Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>


                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.display, facebookDisplayFormFields) }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].form[facebookDisplayFormFields.budget.key] || ''}
                        setting={facebookDisplayFormFields[facebookDisplayFormFields.budget.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].errors[facebookDisplayFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].touched[facebookDisplayFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.display, facebookDisplayFormFields) }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].form[facebookDisplayFormFields.pacing.key] || ''}
                        setting={facebookDisplayFormFields[facebookDisplayFormFields.pacing.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].errors[facebookDisplayFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].touched[facebookDisplayFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.display, facebookDisplayFormFields) }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].form[facebookDisplayFormFields.duration.key] || ''}
                        setting={facebookDisplayFormFields[facebookDisplayFormFields.duration.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].errors[facebookDisplayFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].touched[facebookDisplayFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.display, facebookDisplayFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.facebook.key,enumdataModal.facebook.formType.search)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].form[facebookDisplayFormFields.startDate.key] || ''}
                        setting={facebookDisplayFormFields[facebookDisplayFormFields.startDate.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].errors[facebookDisplayFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].touched[facebookDisplayFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.display]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.display, facebookDisplayFormFields) }}
                        onBlur={() => { }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].form[facebookDisplayFormFields.endDate.key] || ''}
                        setting={facebookDisplayFormFields[facebookDisplayFormFields.endDate.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].errors[facebookDisplayFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].touched[facebookDisplayFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].form[facebookDisplayFormFields.startDate.key] ? form[enumdataModal.facebook.key][enumdataModal.facebook.formType.display].form[facebookDisplayFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.display]}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.facebook.selectAdType.video] ? 'highlightType' : ''}`} style={{ borderRadius: 10 }} onClick={() => selectAdType(enumdataModal.facebook.selectAdType.video)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Video Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.video, facebookVideoFormFields) }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].form[facebookVideoFormFields.budget.key] || ''}
                        setting={facebookVideoFormFields[facebookVideoFormFields.budget.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].errors[facebookVideoFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].touched[facebookVideoFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.video, facebookVideoFormFields) }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].form[facebookVideoFormFields.pacing.key]}
                        setting={facebookVideoFormFields[facebookVideoFormFields.pacing.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].errors[facebookVideoFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].touched[facebookVideoFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.video, facebookVideoFormFields) }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].form[facebookVideoFormFields.duration.key]}
                        setting={facebookVideoFormFields[facebookVideoFormFields.duration.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].errors[facebookVideoFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].touched[facebookVideoFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.video, facebookVideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.facebook.key,enumdataModal.facebook.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].form[facebookVideoFormFields.startDate.key] || ''}
                        setting={facebookVideoFormFields[facebookVideoFormFields.startDate.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].errors[facebookVideoFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].touched[facebookVideoFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.video]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.facebook.key, enumdataModal.facebook.formType.video, facebookVideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.facebook.key,enumdataModal.facebook.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].form[facebookVideoFormFields.endDate.key] || ''}
                        setting={facebookVideoFormFields[facebookVideoFormFields.endDate.key]}
                        error={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].errors[facebookVideoFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].touched[facebookVideoFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].form[facebookVideoFormFields.startDate.key] ? form[enumdataModal.facebook.key][enumdataModal.facebook.formType.video].form[facebookVideoFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.video]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 justify-content-end d-flex p-4" style={{ background: "#F7F8FC" }}>
            <button onClick={() => setfacebookModal(!facebookModal)} className="btn btn-outline-primary">Cancel</button>
            <button onClick={handleSaveFacebookModal} disabled={!selectedModalAdType[enumdataModal.facebook.selectAdType.video] && !selectedModalAdType[enumdataModal.facebook.selectAdType.display]} className="btn btn-primary bg-color-beki ml-3">Save</button>

          </div>
        </div>
      </Modal>

      <Modal open={dv360Modal} size="medium" className='modal-center-adj'>
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header">
            <h5 className="modal-title" style={{ margin: "0 auto", color: "#040B1B" }}>Add Details for DV360</h5>
            <button type="button" onClick={() => setdv360Modal(!dv360Modal)} className="close" data-dismiss="modal" aria-label="Close">
              <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">x</span></div>
            </button>
          </div>
          <div className='modal-body inputUI' style={{ height: "70vh", overflowY: "scroll" }} >
            <div className='row p-3 px-4'>
              <div className="col-md-12">
                <Input
                  onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.campaign.campaignName) }}
                  onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.campaign.campaignName, dv360FormFieldsCampaignName) }}
                  value={form[enumdataModal.dv360.key][enumdataModal.dv360.campaign.campaignName].form[dv360FormFieldsCampaignName.campaignName.key] || ''}
                  setting={dv360FormFieldsCampaignName[dv360FormFieldsCampaignName.campaignName.key]}
                  error={form[enumdataModal.dv360.key][enumdataModal.dv360.campaign.campaignName].errors[dv360FormFieldsCampaignName.campaignName.key]}
                  submited={submited}
                  touched={form[enumdataModal.dv360.key][enumdataModal.dv360.campaign.campaignName].touched[dv360FormFieldsCampaignName.campaignName.key]}
                // disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video]}
                />
              </div>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.dv360.selectAdType.video] ? 'highlightType' : ''}`} style={{ borderRadius: 10, position: "relative" }} onClick={() => selectAdType(enumdataModal.dv360.selectAdType.video)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Video Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.budget.key] || ''}
                        setting={dv360VideoFormFields[dv360VideoFormFields.budget.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].errors[dv360VideoFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].touched[dv360VideoFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.pacing.key]}
                        setting={dv360VideoFormFields[dv360VideoFormFields.pacing.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].errors[dv360VideoFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].touched[dv360VideoFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.duration.key]}
                        setting={dv360VideoFormFields[dv360VideoFormFields.duration.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].errors[dv360VideoFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].touched[dv360VideoFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.dv360.key,enumdataModal.dv360.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.startDate.key] || ''}
                        setting={dv360VideoFormFields[dv360VideoFormFields.startDate.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].errors[dv360VideoFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].touched[dv360VideoFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.dv360.key,enumdataModal.dv360.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.endDate.key] || ''}
                        setting={dv360VideoFormFields[dv360VideoFormFields.endDate.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].errors[dv360VideoFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].touched[dv360VideoFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.startDate.key] ? form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video]}
                      />
                    </div>
                  </div>


                  <CSSTransition
                    in={showFrequencyForm.dv360Video}
                    timeout={300}
                    classNames="form-transition"
                    unmountOnExit
                  >
                    <div>
                      <div class="col-md-12 px-0 pb-2" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Frequency Management</label></div>

                      <div className="col d-flex align-items-center pb-3 px-0">
                        <div className="d-flex align-items-center pr-4">
                          <input
                            type="radio"
                            id="none_frequencyCapdv360Video"
                            name="frequencyCapdv360Video"
                            value="none"
                            checked={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form.selectedFrequencyOption === "none"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "none" } }, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                          />
                          <label htmlFor="none_frequencyCapdv360Video" className="mb-0 pl-2">
                            None
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="limited_frequencyCapdv360Video"
                            name="frequencyCapdv360Video"
                            value="limited"
                            checked={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form.selectedFrequencyOption === "limited"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "limited" } }, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                          />
                          <label htmlFor="limited_frequencyCapdv360Video" className="mb-0 pl-2">
                            Limited
                          </label>
                        </div>
                      </div>




                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>To</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                            value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.frequencyCapTo.key] || ''}
                            setting={dv360VideoFormFields[dv360VideoFormFields.frequencyCapTo.key]}
                            error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].errors[dv360VideoFormFields.frequencyCapTo.key]}
                            submited={submited}
                            touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].touched[dv360VideoFormFields.frequencyCapTo.key]}
                            disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video] || form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form.selectedFrequencyOption === "none"}
                          />
                        </div>
                      </div>

                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Time</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                            value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.frequencyCapTime.key] || ''}
                            setting={dv360VideoFormFields[dv360VideoFormFields.frequencyCapTime.key]}
                            error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].errors[dv360VideoFormFields.frequencyCapTime.key]}
                            submited={submited}
                            touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].touched[dv360VideoFormFields.frequencyCapTime.key]}
                            disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video] || form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form.selectedFrequencyOption === "none"}
                          />
                        </div>
                      </div>


                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
                        <div class="col-md-8 pr-0">
                          <SelectNew
                            onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.video, dv360VideoFormFields) }}
                            value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form[dv360VideoFormFields.frequencyCapPerInterval.key] || ''}
                            setting={dv360VideoFormFields[dv360VideoFormFields.frequencyCapPerInterval.key]}
                            error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].errors[dv360VideoFormFields.frequencyCapPerInterval.key]}
                            submited={submited}
                            touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].touched[dv360VideoFormFields.frequencyCapPerInterval.key]}
                            options={[{ id: 0, name: 'Hours' },
                            { id: 1, name: 'Day' },
                            { id: 2, name: 'Week' },
                            { id: 3, name: 'Month' },
                            { id: 4, name: 'Lifetime' }]}
                            disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video] || form[enumdataModal.dv360.key][enumdataModal.dv360.formType.video].form.selectedFrequencyOption === "none" }
                          />
                        </div>
                      </div>
                    </div>
                  </CSSTransition>
                </div>
                <div className="strategy-bottom-bar border p-2 mx-n4 mb-n4"
                  style={{
                    position: "absolute",
                    right: 24,
                    left: 24,
                    bottom: 24,
                  }}
                  onClick={(e) => { e.stopPropagation() }}>
                  <CSSTransition
                    in={!showFrequencyForm.dv360Video}
                    timeout={{ enter: 300, exit: 200 }}
                    classNames="button-transition"
                    unmountOnExit
                  >
                    <div
                      onClick={() => setShowFrequencyForm({ ...showFrequencyForm, dv360Video: !showFrequencyForm.dv360Video })}
                    >
                      Frequency Capping
                    </div>
                  </CSSTransition>
                </div>
              </div>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.dv360.selectAdType.display] ? 'highlightType' : ''}`} style={{ borderRadius: 10, position: "relative" }} onClick={() => selectAdType(enumdataModal.dv360.selectAdType.display)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Display Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>


                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      {/* <Input
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[dv360DisplayFormFields.budget.key]}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.budget.key]}
                        error={errors[dv360DisplayFormFields.budget.key]}
                        submited={submited}
                        touched={touched[dv360DisplayFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}
                      /> */}
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.budget.key] || ''}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.budget.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].errors[dv360DisplayFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].touched[dv360DisplayFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.pacing.key] || ''}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.pacing.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].errors[dv360DisplayFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].touched[dv360DisplayFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      {/* <SelectNew
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[dv360DisplayFormFields.duration.key]}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.duration.key]}
                        error={errors[dv360DisplayFormFields.duration.key]}
                        submited={submited}
                        touched={touched[dv360DisplayFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}
                      /> */}
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.duration.key] || ''}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.duration.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].errors[dv360DisplayFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].touched[dv360DisplayFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      {/* <Datepicker
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[dv360DisplayFormFields.startDate.key] || ''}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.startDate.key]}
                        error={errors[dv360DisplayFormFields.startDate.key]}
                        submited={submited}
                        touched={touched[dv360DisplayFormFields.startDate.key]}
                        minDate={new Date()}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}

                      /> */}
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.dv360.key,enumdataModal.dv360.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.startDate.key] || ''}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.startDate.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].errors[dv360DisplayFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].touched[dv360DisplayFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      {/* <Datepicker
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[dv360DisplayFormFields.endDate.key] || ''}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.endDate.key]}
                        error={errors[dv360DisplayFormFields.endDate.key]}
                        submited={submited}
                        touched={touched[dv360DisplayFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={new Date()}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}

                      /> */}
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                        onBlur={() => { }}
                        value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.endDate.key] || ''}
                        setting={dv360DisplayFormFields[dv360DisplayFormFields.endDate.key]}
                        error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].errors[dv360DisplayFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].touched[dv360DisplayFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.startDate.key] ? form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <CSSTransition
                    in={showFrequencyForm.dv360Display}
                    timeout={300}
                    classNames="form-transition"
                    unmountOnExit
                  >
                    <div>
                      <div class="col-md-12 px-0 pb-2" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Frequency Management</label></div>

                      <div className="col d-flex align-items-center pb-3 px-0">
                        <div className="d-flex align-items-center pr-4">
                          <input
                            type="radio"
                            id="none_frequencyCapdv360Display"
                            name="frequencyCapdv360Display"
                            value="none"
                            checked={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form.selectedFrequencyOption === "none"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "none" } }, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                          />
                          <label htmlFor="none_frequencyCapdv360Display" className="mb-0 pl-2">
                            None
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="limited_frequencyCapdv360Display"
                            name="frequencyCapdv360Display"
                            value="limited"
                            checked={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form.selectedFrequencyOption === "limited"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "limited" } }, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                          />
                          <label htmlFor="limited_frequencyCapdv360Display" className="mb-0 pl-2">
                            Limited
                          </label>
                        </div>
                      </div>


                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>To</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                            value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.frequencyCapTo.key] || ''}
                            setting={dv360DisplayFormFields[dv360DisplayFormFields.frequencyCapTo.key]}
                            error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].errors[dv360DisplayFormFields.frequencyCapTo.key]}
                            submited={submited}
                            touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].touched[dv360DisplayFormFields.frequencyCapTo.key]}
                            disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display] || form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form.selectedFrequencyOption === "none"}
                          />
                        </div>
                      </div>


                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Time</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                            value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.frequencyCapTime.key] || ''}
                            setting={dv360DisplayFormFields[dv360DisplayFormFields.frequencyCapTime.key]}
                            error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].errors[dv360DisplayFormFields.frequencyCapTime.key]}
                            submited={submited}
                            touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].touched[dv360DisplayFormFields.frequencyCapTime.key]}
                            disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display] || form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form.selectedFrequencyOption === "none"}
                          />
                        </div>
                      </div>


                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
                        <div class="col-md-8 pr-0">
                          <SelectNew
                            onChange={(e) => { handleChange(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.dv360.key, enumdataModal.dv360.formType.display, dv360DisplayFormFields) }}
                            value={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form[dv360DisplayFormFields.frequencyCapPerInterval.key] || ''}
                            setting={dv360DisplayFormFields[dv360DisplayFormFields.frequencyCapPerInterval.key]}
                            error={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].errors[dv360DisplayFormFields.frequencyCapPerInterval.key]}
                            submited={submited}
                            touched={form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].touched[dv360DisplayFormFields.frequencyCapPerInterval.key]}
                            options={[{ id: 0, name: 'Hours' },
                            { id: 1, name: 'Day' },
                            { id: 2, name: 'Week' },
                            { id: 3, name: 'Month' },
                            { id: 4, name: 'Lifetime' }]}
                            disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.display] || form[enumdataModal.dv360.key][enumdataModal.dv360.formType.display].form.selectedFrequencyOption === "none"}
                          />
                        </div>
                      </div>
                    </div>
                  </CSSTransition>

                </div>
                <div className="strategy-bottom-bar border p-2 mx-n4 mb-n4"
                  style={{
                    position: "absolute",
                    right: 24,
                    left: 24,
                    bottom: 24,
                  }}
                  onClick={(e) => { e.stopPropagation() }}>
                  <CSSTransition
                    in={!showFrequencyForm.dv360Display}
                    timeout={{ enter: 300, exit: 200 }}
                    classNames="button-transition"
                    unmountOnExit
                  >
                    <div
                      onClick={() => setShowFrequencyForm({ ...showFrequencyForm, dv360Display: !showFrequencyForm.dv360Display })}
                    >
                      Frequency Capping
                    </div>
                  </CSSTransition>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 justify-content-end d-flex p-4" style={{ background: "#F7F8FC" }}>
            <button onClick={() => setdv360Modal(!dv360Modal)} className="btn btn-outline-primary">Cancel</button>
            <button onClick={handleSaveDV360Modal} disabled={!selectedModalAdType[enumdataModal.dv360.selectAdType.video] && !selectedModalAdType[enumdataModal.dv360.selectAdType.display]} className="btn btn-primary bg-color-beki ml-3">Save</button>

          </div>
        </div>
      </Modal>

      <Modal open={tiktokModal} size="medium" className='modal-center-adj'>
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header">
            <h5 className="modal-title" style={{ margin: "0 auto", color: "#040B1B" }}>Add Details for TikTok</h5>
            <button type="button" onClick={() => settiktokModal(!tiktokModal)} className="close" data-dismiss="modal" aria-label="Close">
              <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">x</span></div>
            </button>
          </div>
          <div className='modal-body inputUI' style={{ height: "70vh", overflowY: "scroll" }} >
            <div className='row p-3 px-4'>
              <div className="col-md-12">
                <Input
                  onChange={(e) => { handleChange(e, enumdataModal.tiktok.key, enumdataModal.tiktok.campaign.campaignName) }}
                  onBlur={(e) => { handleTouch(e, enumdataModal.tiktok.key, enumdataModal.tiktok.campaign.campaignName, tiktokFormFieldsCampaignName) }}
                  value={form[enumdataModal.tiktok.key][enumdataModal.tiktok.campaign.campaignName].form[tiktokFormFieldsCampaignName.campaignName.key] || ''}
                  setting={tiktokFormFieldsCampaignName[tiktokFormFieldsCampaignName.campaignName.key]}
                  error={form[enumdataModal.tiktok.key][enumdataModal.tiktok.campaign.campaignName].errors[tiktokFormFieldsCampaignName.campaignName.key]}
                  submited={submited}
                  touched={form[enumdataModal.tiktok.key][enumdataModal.tiktok.campaign.campaignName].touched[tiktokFormFieldsCampaignName.campaignName.key]}
                // disabled={!selectedModalAdType[enumdataModal.tiktok.selectAdType.search]}
                />
              </div>

              <div className={`col-adj-12 p-4 ${selectedModalAdType[enumdataModal.tiktok.selectAdType.video] ? 'highlightType' : ''}`} style={{ borderRadius: 10 }} onClick={() => selectAdType(enumdataModal.tiktok.selectAdType.video)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Video Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.tiktok.key, enumdataModal.tiktok.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.tiktok.key, enumdataModal.tiktok.formType.video, tiktokVideoFormFields) }}
                        value={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].form[tiktokVideoFormFields.budget.key] || ''}
                        setting={tiktokVideoFormFields[tiktokVideoFormFields.budget.key]}
                        error={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].errors[tiktokVideoFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].touched[tiktokVideoFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.tiktok.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.tiktok.key, enumdataModal.tiktok.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.tiktok.key, enumdataModal.tiktok.formType.video, tiktokVideoFormFields) }}
                        value={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].form[tiktokVideoFormFields.pacing.key]}
                        setting={tiktokVideoFormFields[tiktokVideoFormFields.pacing.key]}
                        error={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].errors[tiktokVideoFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].touched[tiktokVideoFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.tiktok.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.tiktok.key, enumdataModal.tiktok.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.tiktok.key, enumdataModal.tiktok.formType.video, tiktokVideoFormFields) }}
                        value={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].form[tiktokVideoFormFields.duration.key]}
                        setting={tiktokVideoFormFields[tiktokVideoFormFields.duration.key]}
                        error={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].errors[tiktokVideoFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].touched[tiktokVideoFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.tiktok.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.tiktok.key, enumdataModal.tiktok.formType.video, tiktokVideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.tiktok.key,enumdataModal.tiktok.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].form[tiktokVideoFormFields.startDate.key] || ''}
                        setting={tiktokVideoFormFields[tiktokVideoFormFields.startDate.key]}
                        error={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].errors[tiktokVideoFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].touched[tiktokVideoFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.tiktok.selectAdType.video]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.tiktok.key, enumdataModal.tiktok.formType.video, tiktokVideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.tiktok.key,enumdataModal.tiktok.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].form[tiktokVideoFormFields.endDate.key] || ''}
                        setting={tiktokVideoFormFields[tiktokVideoFormFields.endDate.key]}
                        error={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].errors[tiktokVideoFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].touched[tiktokVideoFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].form[tiktokVideoFormFields.startDate.key] ? form[enumdataModal.tiktok.key][enumdataModal.tiktok.formType.video].form[tiktokVideoFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.tiktok.selectAdType.video]}
                      />
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div className="col-md-12 justify-content-end d-flex p-4" style={{ background: "#F7F8FC" }}>
            <button onClick={() => settiktokModal(!tiktokModal)} className="btn btn-outline-primary">Cancel</button>
            <button onClick={handleSaveTikTokModal} disabled={!selectedModalAdType[enumdataModal.tiktok.selectAdType.video]} className="btn btn-primary bg-color-beki ml-3">Save</button>

          </div>
        </div>
      </Modal>

      <Modal open={ionModal} size="medium" className='modal-center-adj'>
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header">
            <h5 className="modal-title" style={{ margin: "0 auto", color: "#040B1B" }}>Add Details for ION</h5>
            <button type="button" onClick={() => setionModal(!ionModal)} className="close" data-dismiss="modal" aria-label="Close">
              <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">x</span></div>
            </button>
          </div>
          <div className='modal-body inputUI' style={{ height: "70vh", overflowY: "scroll" }} >
            <div className='row p-3 px-4'>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.ion.selectAdType.display] ? 'highlightType' : ''}`} style={{ borderRadius: 10, position: "relative" }} onClick={() => selectAdType(enumdataModal.ion.selectAdType.display)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Display Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Camp. Name<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.campaignName.key] || ''}
                        setting={ionDisplayFormFields[ionDisplayFormFields.campaignName.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.campaignName.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.campaignName.key]}
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                      />
                    </div>
                  </div>


                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.budget.key] || ''}
                        setting={ionDisplayFormFields[ionDisplayFormFields.budget.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.pacing.key] || ''}
                        setting={ionDisplayFormFields[ionDisplayFormFields.pacing.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.duration.key] || ''}
                        setting={ionDisplayFormFields[ionDisplayFormFields.duration.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.ion.key,enumdataModal.ion.formType.search)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.startDate.key] || ''}
                        setting={ionDisplayFormFields[ionDisplayFormFields.startDate.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                        onBlur={() => { }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.endDate.key] || ''}
                        setting={ionDisplayFormFields[ionDisplayFormFields.endDate.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.startDate.key] ? form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <CSSTransition
                    in={showFrequencyForm.ionDisplay}
                    timeout={300}
                    classNames="form-transition"
                    unmountOnExit
                  >
                    <div>
                      <div class="col-md-12 px-0 pb-2" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Frequency Management</label></div>

                      <div className="col d-flex align-items-center pb-3 px-0">
                        <div className="d-flex align-items-center pr-4">
                          <input
                            type="radio"
                            id="none_frequencyCapionDisplay"
                            name="frequencyCapionDisplay"
                            value="none"
                            checked={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form.selectedFrequencyOption === "none"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "none" } }, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                          />
                          <label htmlFor="none_frequencyCapionDisplay" className="mb-0 pl-2">
                            None
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="limited_frequencyCapionDisplay"
                            name="frequencyCapionDisplay"
                            value="limited"
                            checked={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form.selectedFrequencyOption === "limited"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "limited" } }, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                          />
                          <label htmlFor="limited_frequencyCapionDisplay" className="mb-0 pl-2">
                            Limited
                          </label>
                        </div>
                      </div>


                  {
                    form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form.selectedFrequencyOption === "limited" && 
                    <React.Fragment>
                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>To</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                            value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.frequencyCapTo.key] || ''}
                            setting={ionDisplayFormFields[ionDisplayFormFields.frequencyCapTo.key]}
                            error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.frequencyCapTo.key]}
                            submited={submited}
                            touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.frequencyCapTo.key]}
                            disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                          />
                        </div>
                      </div>


                      {/* <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Time</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                            value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.frequencyCapTime.key] || ''}
                            setting={ionDisplayFormFields[ionDisplayFormFields.frequencyCapTime.key]}
                            error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.frequencyCapTime.key]}
                            submited={submited}
                            touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.frequencyCapTime.key]}
                            disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                          />
                        </div>
                      </div> */}


                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
                        <div class="col-md-8 pr-0">
                          <SelectNew
                            onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.display, ionDisplayFormFields) }}
                            value={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].form[ionDisplayFormFields.frequencyCapPerInterval.key] || ''}
                            setting={ionDisplayFormFields[ionDisplayFormFields.frequencyCapPerInterval.key]}
                            error={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].errors[ionDisplayFormFields.frequencyCapPerInterval.key]}
                            submited={submited}
                            touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.display].touched[ionDisplayFormFields.frequencyCapPerInterval.key]}
                            options={ionViFrequencyOption}
                            disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.display]}
                          />
                        </div>
                      </div>
                      </React.Fragment>
                  }
                    </div>
                  </CSSTransition>
                </div>
                {
                  !showFrequencyForm.ionDisplay && 
                  <div className="strategy-bottom-bar border p-2 mx-n4 mb-n4"
                  style={{
                    position: "absolute",
                    right: 24,
                    left: 24,
                    bottom: 24,
                  }}
                  onClick={(e) => { e.stopPropagation() }}>
                  <CSSTransition
                    in={!showFrequencyForm.ionDisplay}
                    timeout={{ enter: 300, exit: 200 }}
                    classNames="button-transition"
                    unmountOnExit
                  >
                    <div
                      onClick={() => setShowFrequencyForm({ ...showFrequencyForm, ionDisplay: !showFrequencyForm.ionDisplay })}
                    >
                      Frequency Capping
                    </div>
                  </CSSTransition>
                </div>
                }
                
              </div>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.ion.selectAdType.video] ? 'highlightType' : ''}`} style={{ borderRadius: 10, position: "relative" }} onClick={() => selectAdType(enumdataModal.ion.selectAdType.video)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Video Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Camp. Name<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.campaignName.key] || ''}
                        setting={ionVideoFormFields[ionVideoFormFields.campaignName.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.campaignName.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.campaignName.key]}
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.budget.key] || ''}
                        setting={ionVideoFormFields[ionVideoFormFields.budget.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.pacing.key]}
                        setting={ionVideoFormFields[ionVideoFormFields.pacing.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.duration.key]}
                        setting={ionVideoFormFields[ionVideoFormFields.duration.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.ion.key,enumdataModal.ion.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.startDate.key] || ''}
                        setting={ionVideoFormFields[ionVideoFormFields.startDate.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.ion.key,enumdataModal.ion.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.endDate.key] || ''}
                        setting={ionVideoFormFields[ionVideoFormFields.endDate.key]}
                        error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.startDate.key] ? form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <CSSTransition
                    in={showFrequencyForm.ionVideo}
                    timeout={300}
                    classNames="form-transition"
                    unmountOnExit
                  >
                    <div>
                      <div class="col-md-12 px-0 pb-2" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Frequency Management</label></div>

                      <div className="col d-flex align-items-center pb-3 px-0">
                        <div className="d-flex align-items-center pr-4">
                          <input
                            type="radio"
                            id="none_frequencyCapionVideo"
                            name="frequencyCapionVideo"
                            value="none"
                            checked={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form.selectedFrequencyOption === "none"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "none" } }, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                          />
                          <label htmlFor="none_frequencyCapionVideo" className="mb-0 pl-2">
                            None
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="limited_frequencyCapionVideo"
                            name="frequencyCapionVideo"
                            value="limited"
                            checked={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form.selectedFrequencyOption === "limited"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "limited" } }, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                          />
                          <label htmlFor="limited_frequencyCapionVideo" className="mb-0 pl-2">
                            Limited
                          </label>
                        </div>
                      </div>



                      {
                        form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form.selectedFrequencyOption === "limited" &&
                        <React.Fragment>
                          <div className='d-flex justify-content-between' >
                            <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>To</label></div>
                            <div class="col-md-8 pr-0">
                              <Input
                                onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video) }}
                                onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                                value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.frequencyCapTo.key] || ''}
                                setting={ionVideoFormFields[ionVideoFormFields.frequencyCapTo.key]}
                                error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.frequencyCapTo.key]}
                                submited={submited}
                                touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.frequencyCapTo.key]}
                                disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                              />
                            </div>
                          </div>


                          {/* <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Time</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                            value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.frequencyCapTime.key] || ''}
                            setting={ionVideoFormFields[ionVideoFormFields.frequencyCapTime.key]}
                            error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.frequencyCapTime.key]}
                            submited={submited}
                            touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.frequencyCapTime.key]}
                            disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                          />
                        </div>
                      </div> */}


                          <div className='d-flex justify-content-between' >
                            <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
                            <div class="col-md-8 pr-0">
                              <SelectNew
                                onChange={(e) => { handleChange(e, enumdataModal.ion.key, enumdataModal.ion.formType.video) }}
                                onBlur={(e) => { handleTouch(e, enumdataModal.ion.key, enumdataModal.ion.formType.video, ionVideoFormFields) }}
                                value={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].form[ionVideoFormFields.frequencyCapPerInterval.key] || ''}
                                setting={ionVideoFormFields[ionVideoFormFields.frequencyCapPerInterval.key]}
                                error={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].errors[ionVideoFormFields.frequencyCapPerInterval.key]}
                                submited={submited}
                                touched={form[enumdataModal.ion.key][enumdataModal.ion.formType.video].touched[ionVideoFormFields.frequencyCapPerInterval.key]}
                                options={ionViFrequencyOption}
                                disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video]}
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      }

                    </div>
                  </CSSTransition>
                </div>
                {
                  !showFrequencyForm.ionVideo &&
                  <div className="strategy-bottom-bar border p-2 mx-n4 mb-n4"
                    style={{
                      position: "absolute",
                      right: 24,
                      left: 24,
                      bottom: 24,
                    }}
                    onClick={(e) => { e.stopPropagation() }}>
                    <CSSTransition
                      in={!showFrequencyForm.ionVideo}
                      timeout={{ enter: 300, exit: 200 }}
                      classNames="button-transition"
                      unmountOnExit
                    >
                      <div
                        onClick={() => setShowFrequencyForm({ ...showFrequencyForm, ionVideo: !showFrequencyForm.ionVideo })}
                      >
                        Frequency Capping
                      </div>
                    </CSSTransition>
                  </div>
                }

              </div>
            </div>
          </div>
          <div className="col-md-12 justify-content-end d-flex p-4" style={{ background: "#F7F8FC" }}>
            <button onClick={() => setionModal(!ionModal)} className="btn btn-outline-primary">Cancel</button>
            <button onClick={handleSaveIonModal} disabled={!selectedModalAdType[enumdataModal.ion.selectAdType.video] && !selectedModalAdType[enumdataModal.ion.selectAdType.display]} className="btn btn-primary bg-color-beki ml-3">Save</button>

          </div>
        </div>
      </Modal>

      <Modal open={viAdsModal} size="medium" className='modal-center-adj'>
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header">
            <h5 className="modal-title" style={{ margin: "0 auto", color: "#040B1B" }}>Add Details for ViAds</h5>
            <button type="button" onClick={() => setViadsModal(!viAdsModal)} className="close" data-dismiss="modal" aria-label="Close">
              <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">x</span></div>
            </button>
          </div>
          <div className='modal-body inputUI' style={{ height: "70vh", overflowY: "scroll" }} >
            <div className='row p-3 px-4'>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.viads.selectAdType.display] ? 'highlightType' : ''}`} style={{ borderRadius: 10 }} onClick={() => selectAdType(enumdataModal.viads.selectAdType.display)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Display Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Camp. Name<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.campaignName.key] || ''}
                        setting={viAdsDisplayFormFields[viAdsDisplayFormFields.campaignName.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.campaignName.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.campaignName.key]}
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                      />
                    </div>
                  </div>


                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.budget.key] || ''}
                        setting={viAdsDisplayFormFields[viAdsDisplayFormFields.budget.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.pacing.key] || ''}
                        setting={viAdsDisplayFormFields[viAdsDisplayFormFields.pacing.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.duration.key] || ''}
                        setting={viAdsDisplayFormFields[viAdsDisplayFormFields.duration.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.viads.key,enumdataModal.viads.formType.search)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.startDate.key] || ''}
                        setting={viAdsDisplayFormFields[viAdsDisplayFormFields.startDate.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                      />
                    </div>
                    
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                        onBlur={() => { }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.endDate.key] || ''}
                        setting={viAdsDisplayFormFields[viAdsDisplayFormFields.endDate.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.startDate.key] ? form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                      />
                    </div>
                  </div>
                  <CSSTransition
                    in={showFrequencyForm.viDisplay}
                    timeout={300}
                    classNames="form-transition"
                    unmountOnExit
                  >
                    <div>
                      <div class="col-md-12 px-0 pb-2" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Frequency Management</label></div>

                      <div className="col d-flex align-items-center pb-3 px-0">
                        <div className="d-flex align-items-center pr-4">
                          <input
                            type="radio"
                            id="none_frequencyCapionDisplay"
                            name="frequencyCapionDisplay"
                            value="none"
                            checked={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form.selectedFrequencyOption === "none"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "none" } }, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                          />
                          <label htmlFor="none_frequencyCapionDisplay" className="mb-0 pl-2">
                            None
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="limited_frequencyCapionDisplay"
                            name="frequencyCapionDisplay"
                            value="limited"
                            checked={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form.selectedFrequencyOption === "limited"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "limited" } }, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                          />
                          <label htmlFor="limited_frequencyCapionDisplay" className="mb-0 pl-2">
                            Limited
                          </label>
                        </div>
                      </div>


                     {
                      form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form.selectedFrequencyOption === "limited" && 
                      <React.Fragment>
                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>To</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                            value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.frequencyCapTo.key] || ''}
                            setting={viAdsDisplayFormFields[viAdsDisplayFormFields.frequencyCapTo.key]}
                            error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.frequencyCapTo.key]}
                            submited={submited}
                            touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.frequencyCapTo.key]}
                            disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                          />
                        </div>
                      </div>


                      {/* <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Time</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                            value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.frequencyCapTime.key] || ''}
                            setting={viAdsDisplayFormFields[viAdsDisplayFormFields.frequencyCapTime.key]}
                            error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.frequencyCapTime.key]}
                            submited={submited}
                            touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.frequencyCapTime.key]}
                            disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                          />
                        </div>
                      </div> */}


                      <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
                        <div class="col-md-8 pr-0">
                          <SelectNew
                            onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.display) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.display, viAdsDisplayFormFields) }}
                            value={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].form[viAdsDisplayFormFields.frequencyCapPerInterval.key] || ''}
                            setting={viAdsDisplayFormFields[viAdsDisplayFormFields.frequencyCapPerInterval.key]}
                            error={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].errors[viAdsDisplayFormFields.frequencyCapPerInterval.key]}
                            submited={submited}
                            touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.display].touched[viAdsDisplayFormFields.frequencyCapPerInterval.key]}
                            options={ionViFrequencyOption}
                            disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.display]}
                          />
                        </div>
                      </div>
                      </React.Fragment>
                    }
                    </div>
                  </CSSTransition>
                </div>

{
  !showFrequencyForm.viDisplay && 
                <div className="strategy-bottom-bar border p-2 mx-n4 mb-n4" onClick={(e) => { e.stopPropagation() }}>
                  <CSSTransition
                    in={!showFrequencyForm.viDisplay}
                    timeout={{ enter: 300, exit: 200 }}
                    classNames="button-transition"
                    unmountOnExit
                  >
                    <div
                      onClick={() => setShowFrequencyForm({ ...showFrequencyForm, viDisplay: !showFrequencyForm.viDisplay })}
                    >
                      Frequency Capping
                    </div>
                  </CSSTransition>
                </div>
}

              </div>
              <div className={`col-adj p-4 ${selectedModalAdType[enumdataModal.viads.selectAdType.video] ? 'highlightType' : ''}`} style={{ borderRadius: 10 }} onClick={() => selectAdType(enumdataModal.viads.selectAdType.video)}>
                <div style={{ color: "#040B1B", fontSize: 18, marginBottom: 15 }} >Video Media</div>
                <div className='' onClick={(e) => { e.stopPropagation() }}>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Camp. Name<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.campaignName.key] || ''}
                        setting={viAdsVideoFormFields[viAdsVideoFormFields.campaignName.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.campaignName.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.campaignName.key]}
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>{currency ? `Budget (${currency.value})` : 'Budget'}<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Input
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.budget.key] || ''}
                        setting={viAdsVideoFormFields[viAdsVideoFormFields.budget.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.budget.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.budget.key]}
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Pacing<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.pacing.key]}
                        setting={viAdsVideoFormFields[viAdsVideoFormFields.pacing.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.pacing.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.pacing.key]}
                        options={pacingData}
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Duration<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <SelectNew
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video) }}
                        onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.duration.key]}
                        setting={viAdsVideoFormFields[viAdsVideoFormFields.duration.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.duration.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.duration.key]}
                        options={durationData}
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Start Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.viads.key,enumdataModal.viads.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.startDate.key] || ''}
                        setting={viAdsVideoFormFields[viAdsVideoFormFields.startDate.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.startDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.startDate.key]}
                        minDate={new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                      />
                    </div>
                  </div>
                  <div className='d-flex justify-content-between' >
                    <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>End Date<span class="text-danger">*</span></label></div>
                    <div class="col-md-8 pr-0">
                      <Datepicker
                        onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                        // onBlur={(e)=>{handleTouch(e,enumdataModal.viads.key,enumdataModal.viads.formType.video)}}
                        onBlur={() => { }}
                        value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.endDate.key] || ''}
                        setting={viAdsVideoFormFields[viAdsVideoFormFields.endDate.key]}
                        error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.endDate.key]}
                        submited={submited}
                        touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.endDate.key]}
                        isDisabled={form.startDate ? false : true}
                        minDate={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.startDate.key] ? form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.startDate.key] : new Date()}
                        maxDate={basicDetailsForm ? basicDetailsForm.endDate : ''}
                        showDisabledMonthNavigation
                        disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                      />
                    </div>
                  </div>
                  <CSSTransition
                    in={showFrequencyForm.viVideo}
                    timeout={300}
                    classNames="form-transition"
                    unmountOnExit
                  >
                    <div>
                      <div class="col-md-12 px-0 pb-2" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Frequency Management</label></div>

                      <div className="col d-flex align-items-center pb-3 px-0">
                        <div className="d-flex align-items-center pr-4">
                          <input
                            type="radio"
                            id="none_frequencyCapionVideo"
                            name="frequencyCapionVideo"
                            value="none"
                            checked={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form.selectedFrequencyOption === "none"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "none" } }, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                          />
                          <label htmlFor="none_frequencyCapionVideo" className="mb-0 pl-2">
                            None
                          </label>
                        </div>
                        <div className="d-flex align-items-center">
                          <input
                            type="radio"
                            id="limited_frequencyCapionVideo"
                            name="frequencyCapionVideo"
                            value="limited"
                            checked={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form.selectedFrequencyOption === "limited"}
                            onChange={(e) => { handleChange({ target: { name: "selectedFrequencyOption", value: "limited" } }, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                          />
                          <label htmlFor="limited_frequencyCapionVideo" className="mb-0 pl-2">
                            Limited
                          </label>
                        </div>
                      </div>


                      {
                        form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form.selectedFrequencyOption === "limited" &&

                        <React.Fragment>

                          <div className='d-flex justify-content-between' >
                            <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>To</label></div>
                            <div class="col-md-8 pr-0">
                              <Input
                                onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video) }}
                                onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                                value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.frequencyCapTo.key] || ''}
                                setting={viAdsVideoFormFields[viAdsVideoFormFields.frequencyCapTo.key]}
                                error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.frequencyCapTo.key]}
                                submited={submited}
                                touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.frequencyCapTo.key]}
                                disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                              />
                            </div>
                          </div>


                          {/* <div className='d-flex justify-content-between' >
                        <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Time</label></div>
                        <div class="col-md-8 pr-0">
                          <Input
                            onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video) }}
                            onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                            value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.frequencyCapTime.key] || ''}
                            setting={viAdsVideoFormFields[viAdsVideoFormFields.frequencyCapTime.key]}
                            error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.frequencyCapTime.key]}
                            submited={submited}
                            touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.frequencyCapTime.key]}
                            disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                          />
                        </div>
                      </div> */}


                          <div className='d-flex justify-content-between' >
                            <div class="col-md-4 px-0" style={{ position: "relative", right: "12px" }}><label class=" col-md-12 mt-2" style={{ fontSize: "12px" }}>Per</label></div>
                            <div class="col-md-8 pr-0">
                              <SelectNew
                                onChange={(e) => { handleChange(e, enumdataModal.viads.key, enumdataModal.viads.formType.video) }}
                                onBlur={(e) => { handleTouch(e, enumdataModal.viads.key, enumdataModal.viads.formType.video, viAdsVideoFormFields) }}
                                value={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].form[viAdsVideoFormFields.frequencyCapPerInterval.key] || ''}
                                setting={viAdsVideoFormFields[viAdsVideoFormFields.frequencyCapPerInterval.key]}
                                error={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].errors[viAdsVideoFormFields.frequencyCapPerInterval.key]}
                                submited={submited}
                                touched={form[enumdataModal.viads.key][enumdataModal.viads.formType.video].touched[viAdsVideoFormFields.frequencyCapPerInterval.key]}
                                options={ionViFrequencyOption}
                                disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video]}
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      }

                    </div>
                  </CSSTransition>
                </div>
                {
                  !showFrequencyForm.viVideo && 
                <div className="strategy-bottom-bar border p-2 mx-n4 mb-n4" onClick={(e) => { e.stopPropagation() }}>
                  <CSSTransition
                    in={!showFrequencyForm.viVideo}
                    timeout={{ enter: 300, exit: 200 }}
                    classNames="button-transition"
                    unmountOnExit
                  >
                    <div
                      onClick={() => setShowFrequencyForm({ ...showFrequencyForm, viVideo: !showFrequencyForm.viVideo })}
                    >
                      Frequency Capping
                    </div>
                  </CSSTransition>
                </div>
                }

              </div>
            </div>
          </div>
          <div className="col-md-12 justify-content-end d-flex p-4" style={{ background: "#F7F8FC" }}>
            <button onClick={() => setViadsModal(!viAdsModal)} className="btn btn-outline-primary">Cancel</button>
            <button onClick={handleSaveViAdsModal} disabled={!selectedModalAdType[enumdataModal.viads.selectAdType.video] && !selectedModalAdType[enumdataModal.viads.selectAdType.display]} className="btn btn-primary bg-color-beki ml-3">Save</button>

          </div>
        </div>
      </Modal>


    </div>
  );
};

export default withRouter(StepTwoContent);
